import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import { notifyError } from "../utils/notify";

export const firebaseConfig = {
  apiKey: "AIzaSyAGja_x1__V1qR3QMTwQD6048r0zWwlWzA",
  authDomain: "zapai-8585e.firebaseapp.com",
  projectId: "zapai-8585e",
  storageBucket: "zapai-8585e.firebasestorage.app",
  messagingSenderId: "438341250413",
  appId: "1:438341250413:web:fa004fd2b91b27c8a7be64",
  measurementId: "G-RVQLMPK1DL",
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const storage = firebase.storage();

export const createAdminProfileDocument = async (userAuth, additionalData) => {
  if (!userAuth) return;

  const adminRef = firestore.doc(`admins/${userAuth.uid}`);

  const snapShot = await adminRef.get();
  if (!snapShot.exists) {
    const { name, email } = userAuth;
    const createdAt = new Date();
    try {
      await adminRef.set({
        name,
        email,
        createdAt,
        pending_orders: [],
        balance: 0,
        used_balance: 0,
        successfully_delivered_orders: [],
        remaining_balance: 0,
        ...additionalData,
      });
    } catch (error) {
      console.log("error creating admin", error.message);
    }
  }
  return adminRef;
};
export const updateAllUser = async () => {
  const usersRef = firestore.collection("users");
  const users = await usersRef.get();

  users.forEach(async (doc) => {
    const userRef = firestore.doc(`users/${doc.id}`);
    const user = await userRef.get();
    // do any updates here
  });
};
export const updateTransactionOrderStatus = async (orderObj) => {
  const transactionsRef = firestore
    .collection("transactions")
    .where("subCategory", "==", `Order Id:${orderObj.orderId}`);
  const transactions = await transactionsRef.get();

  transactions.forEach(async (doc) => {
    const transactionRef = firestore.doc(`transactions/${doc.id}`);
    const transaction = await transactionRef.get();
    // do any updates here
    await transactionRef.update({
      ...transaction.data(),
      orderStatus: orderObj.orderStatus,
    });
  });
};

export const getAllDeviceTokens = async () => {
  const tokensCollectionRef = firestore.collection("deviceTokens");
  try {
    const tokens = await tokensCollectionRef.get();
    const tokensArray = [];
    tokens.forEach((doc) => {
      // console.log(doc.id, " => ", doc.data());
      tokensArray.push(doc.data().deviceToken[0]);
    });
    return tokensArray;
  } catch (error) {
    notifyError(error.message || String(error));
    return [];
  }
};

export const uploadProduct = async (productObj) => {
  const productRef = firestore.doc(`products/${productObj.id}`);
  const snapShot = await productRef.get();
  delete productObj.file;
  const newProductObj = {
    ...productObj,
  };
  if (!snapShot.exists) {
    try {
      await productRef.set({
        ...newProductObj,
      });
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    if (productObj.edited) {
      await productRef.update({
        ...newProductObj,
      });
    } else {
      notifyError(
        "there is already a product with this given prodcut Id, please change the product Id and upload again",
      );
    }
  }
  const updatedSnapShot = await productRef.get();
  if (updatedSnapShot.exists) {
    try {
      await firestore
        .collection("productList")
        .doc(productObj.id)
        .set(
          stripProductForList({ id: productObj.id, ...updatedSnapShot.data() }),
          { merge: true },
        );
    } catch (e) {
      console.error("productList sync failed", e);
    }
  }
  return updatedSnapShot.data();
};
export const uploadDisplayedVariation = async (variationObj) => {
  const productRef = firestore.doc(`variations/${variationObj.id}`);
  const snapShot = await productRef.get();

  const newVariationObj = {
    ...variationObj,
  };
  if (!snapShot.exists) {
    try {
      await productRef.set({
        ...newVariationObj,
      });
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    await productRef.update({
      ...newVariationObj,
    });
  }
  const updatedSnapShot = await productRef.get();
  return updatedSnapShot.data();
};
export const uploadProductTax = async (productObj) => {
  const productRef = firestore.doc(`taxes/${productObj.id}`);
  const snapShot = await productRef.get();
  const newProductObj = { ...productObj };
  if (!snapShot.exists) {
    try {
      productRef.set({
        ...newProductObj,
      });
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError(
      "there is already a product with this given prodcut Id, please change the product Id and upload again",
    );
  }
};
export const uploadImageRechargeRequest = async (file) => {
  const imageRef = storage.ref(`rechargeRequests/${file.name}`);

  try {
    await imageRef.put(file);
    var imgUrl = [];
    await imageRef.getDownloadURL().then((url) => {
      console.log(url);
      imgUrl.push(url);
    });
    return imgUrl[0];
  } catch (error) {
    return null;
  }
};
export const uploadImage = async (file, folder) => {
  try {
    const formData = new FormData();
    formData.append("image", file);
    formData.append("folder", folder);

    const response = await fetch("https://zapai.com.bd/api/images/upload", {
      method: "POST",
      body: formData,
    });

    const result = await response.json();
    console.log(result);
    if (response.ok && result.imageUrl) {
      return result.imageUrl; // 👈 URL like: https://yourdomain.com/images/banners/filename.jpg
    } else {
      console.error("❌ Upload failed:", result.error);
      return null;
    }
  } catch (error) {
    console.error("❌ Upload error:", error);
    return null;
  }
};

export const deleteImage = async (imageUrl) => {
  try {
    const res = await fetch("https://zapai.com.bd/api/images/delete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ imageUrl }), // 👈 key point
    });

    const result = await res.json();

    if (res.ok) {
      console.log("✅ Image deleted successfully");
    } else {
      console.error("❌ Failed to delete image:", result.error);
    }
  } catch (error) {
    console.error("❌ Error calling delete API:", error);
  }
};

export const updateImage = async (file, oldImageUrl, folder) => {
  const formData = new FormData();
  formData.append("image", file); // `file` is a File object from input
  formData.append("oldImageUrl", oldImageUrl || "");
  formData.append("folder", folder || "default");

  try {
    const response = await fetch("https://zapai.com.bd/api/images/update", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Failed to update image.");
    }

    console.log("Update Response:", data);

    // ✅ Return imageUrl if present
    return data.imageUrl || oldImageUrl;
  } catch (error) {
    console.error("Image update failed:", error);
    return oldImageUrl; // fallback to previous image if update fails
  }
};

export const uploadAliProduct = async (productObj) => {
  const productRef = firestore.doc(`aliproducts/${productObj.id}`);
  const snapShot = await productRef.get();
  const newProductObj = { ...productObj };
  if (!snapShot.exists) {
    try {
      productRef.set({
        ...newProductObj,
      });
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError(
      "this product is already added to your website. try adding different product",
    );
  }
};

let lastVisible = null; // This will hold the last document snapshot from the previous query
const cache = {}; // Store results in the cache for efficiency

export const getAllProducts = async (pageNo) => {
  console.log(`Fetching page: ${pageNo}`);
  const productsPerPage = 100;
  let productsArray = [];

  // Check if the data for this page is already in the cache
  if (cache[pageNo]) {
    console.log("Returning from cache");
    return cache[pageNo];
  }

  try {
    // Initial query, ordered by 'name', limited to productsPerPage
    let query = firestore
      .collection("products")
      .orderBy("name")
      .limit(productsPerPage);

    // If we're beyond the first page, use the last document from the previous page as the cursor
    if (pageNo > 1 && lastVisible) {
      query = query.startAfter(lastVisible); // Start after the last document of the previous page
    }

    // Fetch the products snapshot
    const productsSnapshot = await query.get();

    // Check if there are any products
    if (!productsSnapshot.empty) {
      // Update the lastVisible document to the last document in the current snapshot
      lastVisible = productsSnapshot.docs[productsSnapshot.docs.length - 1];

      // Push the fetched products to the array
      productsSnapshot.forEach((doc) => {
        productsArray.push(doc.data());
      });

      // Cache the result for the current page
      cache[pageNo] = productsArray;

      console.log(
        `Fetched ${productsArray.length} products for page ${pageNo}`,
      );
      return productsArray;
    } else {
      console.log("No products found");
      return []; // Return an empty array if no products are found
    }
  } catch (error) {
    console.error("Error fetching products:", error);
    notifyError("Failed to fetch products. Please try again.");
  }
};

export const getAllReviews = async () => {
  const productsCollectionRef = firestore
    .collection("products")
    .orderBy("reviews");
  try {
    const products = await productsCollectionRef.get();
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllProductsTax = async () => {
  const productsCollectionRef = firestore.collection("taxes");
  try {
    const products = await productsCollectionRef.get();
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllAliProducts = async () => {
  const aliProductsCollectionRef = firestore.collection("aliproducts");
  try {
    const products = await aliProductsCollectionRef.get();
    const aliProductsArray = [];
    products.forEach((doc) => {
      aliProductsArray.push(doc.data());
    });
    return aliProductsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteProduct = async (id) => {
  const productRef = firestore.doc(`products/${id}`);
  try {
    await productRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteReview = async (productId, reviewId) => {
  const productRef = firestore.doc(`products/${productId}`);
  const product = await productRef.get();
  let updatedReviews = [];
  product.data().reviews.map((review) => {
    if (review.id != reviewId) {
      updatedReviews.push(review);
    }
  });
  try {
    await productRef.update({ ...product.data(), reviews: updatedReviews });
    const updatedProduct = await productRef.get();
    return updatedProduct.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteProductTax = async (id) => {
  const productRef = firestore.doc(`taxes/${id}`);
  try {
    await productRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const updateProductTax = async (productObj) => {
  const productRef = firestore.doc(`taxes/${productObj.id}`);
  try {
    await productRef.update({ ...productObj });
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getSingleProductTax = async (id) => {
  const productRef = firestore.doc(`taxes/${id}`);
  try {
    const product = await productRef.get();
    return product.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getFreeShipping = async () => {
  const productRef = firestore.doc(`freeShipping/freeShipping`);
  try {
    const product = await productRef.get();
    return product.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getSingleProduct = async (id) => {
  const productRef = firestore.doc(`products/${id}`);
  try {
    const product = await productRef.get();
    return product.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadDraftProduct = async (productObj) => {
  const ref = firestore.doc(`draft-products/${productObj.id}`);
  delete productObj.file;
  try {
    await ref.set({ ...productObj, isDraft: true });
    return (await ref.get()).data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllDraftProducts = async () => {
  try {
    const [draftSnap, statusSnap] = await Promise.all([
      firestore.collection("draft-products").get(),
      firestore.collection("products").where("status", "==", "draft").get(),
    ]);
    const drafts = draftSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    const statusDrafts = statusSnap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
      _isStatusDraft: true,
    }));
    return [...drafts, ...statusDrafts];
  } catch (error) {
    notifyError(error.message || String(error));
    return [];
  }
};

export const getSingleDraftProduct = async (id) => {
  try {
    const snap = await firestore.doc(`draft-products/${id}`).get();
    return snap.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const publishDraftProduct = async (productObj) => {
  const product = await uploadProduct(productObj);
  await firestore.doc(`draft-products/${productObj.id}`).delete();
  return product;
};

export const deleteDraftProduct = async (id) => {
  try {
    await firestore.doc(`draft-products/${id}`).delete();
    return id;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getDisplayedVariation = async (id) => {
  const productRef = firestore.doc(`variations/${id}`);
  try {
    const product = await productRef.get();
    return product.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

// get all users

export const getAllUsers = async () => {
  const usersCollectionRef = firestore.collection("users");
  try {
    const users = await usersCollectionRef.get();
    const usersArray = [];
    users.forEach((doc) => {
      usersArray.push({ uid: doc.id, ...doc.data() });
    });
    return usersArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteUser = async (id) => {
  const productRef = firestore.doc(`users/${id}`);
  try {
    await productRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

// Orders management (get all orders)

export const getAllOrders = async (orderStatus, lastOrderId = null, startTs = null, endTs = null) => {
  let queryRef = firestore.collection("orders");

  if (orderStatus !== "All Orders") {
    queryRef = queryRef.where("orderStatus", "==", orderStatus);
  }

  if (startTs != null && endTs != null) {
    const startTimestamp = firebase.firestore.Timestamp.fromMillis(startTs);
    const endTimestamp   = firebase.firestore.Timestamp.fromMillis(endTs);
    queryRef = queryRef
      .where("createdAt", ">=", startTimestamp)
      .where("createdAt", "<=", endTimestamp);
  }

  queryRef = queryRef.orderBy("createdAt", "desc").limit(20);

  if (lastOrderId) {
    const lastSnap = await firestore
      .collection("orders")
      .doc(lastOrderId)
      .get();
    if (!lastSnap.exists) {
      return { orders: [], lastVisible: null, hasMore: false };
    }
    const lastData = lastSnap.data();
    if (!lastData || lastData.createdAt === undefined) {
      throw new Error("Invalid last document: missing 'createdAt' field.");
    }
    queryRef = queryRef.startAfter(lastData.createdAt);
  }

  try {
    const snapshot = await queryRef.get();
    const ordersArray = [];
    snapshot.forEach((doc) => {
      ordersArray.push({ id: doc.id, ...doc.data() });
    });
    const newLastDocId = snapshot.docs[snapshot.docs.length - 1]?.id || null;
    return {
      orders: ordersArray,
      lastVisible: newLastDocId,
      hasMore: snapshot.size > 0,
    };
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};

// ─── ordersList helpers ────────────────────────────────────────────────────

const stripOrderForList = (order) => {
  const addrArr =
    (order.currentUser && order.currentUser.address) ||
    (order.guest && order.guest.address) ||
    [];
  const addr = addrArr.find((a) => a.defaultShipping) || addrArr[0] || null;

  return {
    id: order.id,
    date: order.date || null,
    createdAt: order.createdAt || null,
    orderStatus: order.orderStatus || "",
    orderNote: order.orderNote || "",
    currentUser: {
      displayName:
        (order.currentUser && order.currentUser.displayName) || "Guest",
    },
    deliveryAddress: addr
      ? {
          fullName: addr.fullName || "",
          mobileNo: addr.mobileNo || "",
          address: addr.address || "",
          district: addr.district || "",
          division: addr.division || "",
        }
      : null,
    subTotal: order.subTotal || 0,
    deliveryCharge: order.deliveryCharge || 0,
    discountApplied: order.discountApplied || 0,
    couponApplied:
      order.couponApplied
        ? { discount: order.couponApplied.discount || 0 }
        : null,
    finalDiscount: order.finalDiscount || 0,
    payments: order.payments || [],
    paymentStatus: order.paymentStatus || "",
    orders: (order.orders || []).map((item) => ({
      name: (item.product && item.product.name) || item.name || "",
      image:
        item.productImage ||
        (item.selectedVariation &&
          item.selectedVariation.pictures &&
          item.selectedVariation.pictures[0]) ||
        (item.product &&
          item.product.pictures &&
          item.product.pictures[0]) ||
        "",
      quantity: item.quantity || 1,
    })),
    courier: order.courier
      ? {
          pathao: order.courier.pathao || null,
          consignment: order.courier.consignment
            ? {
                consignment_id:
                  order.courier.consignment.consignment_id || null,
                status: order.courier.consignment.status || null,
              }
            : null,
          consignment_id: order.courier.consignment_id || null,
        }
      : null,
    totalBill:
      (order.subTotal || 0) +
      (order.deliveryCharge || 0) -
      (order.discountApplied || 0) -
      (order.couponApplied ? order.couponApplied.discount || 0 : 0) -
      (order.finalDiscount || 0),
    totalPaid: (order.payments || []).reduce(
      (s, p) => s + (parseInt(p.amount) || 0),
      0,
    ),
  };
};

const stripProductForList = (product) => ({
  id: product.id,
  name: product.name || "",
  pictures: product.pictures?.slice(0, 1) || [],
  pictures2: product.pictures2?.slice(0, 1) || [],
  price: product.price || 0,
  salePrice: product.salePrice || 0,
  stockStatus: product.stockStatus || "",
  inventory: product.inventory || 0,
  displayedVariations: (product.displayedVariations || []).map((v) => ({
    id: v.id,
    combination: (v.combination || []).map((c) => ({ name: c.name })),
    stockStatus: v.stockStatus || "",
    inventory: v.inventory || 0,
    price: v.price || 0,
    salePrice: v.salePrice || 0,
    pictures: v.pictures?.slice(0, 1) || [],
  })),
  selectedCategories: (product.selectedCategories || []).map((c) => ({
    id: c.id,
    name: c.name,
  })),
  selectedBrands: (product.selectedBrands || []).map((b) => ({
    id: b.id,
    name: b.name,
  })),
  selectedTags: product.selectedTags || [],
  published: product.published || "",
  publishedOn: product.publishedOn || "",
  edited: product.edited || false,
  totalSold: product.totalSold || 0,
  isPreOrder: product.isPreOrder || false,
  new: product.new || false,
  checkedValues: product.checkedValues || [],
  checkedValues2: product.checkedValues2 || [],
  selectedCampaign: product.selectedCampaign || "",
});

export const migrateProductsToProductList = async (onProgress) => {
  let lastDoc = null;
  let total = 0;
  const BATCH_SIZE = 20;
  while (true) {
    let q = firestore.collection("products").orderBy("name").limit(BATCH_SIZE);
    if (lastDoc) q = q.startAfter(lastDoc);
    const snap = await q.get();
    if (snap.empty) break;
    const batch = firestore.batch();
    snap.docs.forEach((doc) => {
      const p = { id: doc.id, ...doc.data() };
      batch.set(
        firestore.collection("productList").doc(doc.id),
        stripProductForList(p),
        { merge: true },
      );
    });
    await batch.commit();
    total += snap.docs.length;
    lastDoc = snap.docs[snap.docs.length - 1];
    if (onProgress) onProgress(total);
    if (snap.docs.length < BATCH_SIZE) break;
  }
  return total;
};

export const getOrdersList = async (
  orderStatus,
  lastOrderId = null,
  startTs = null,
  endTs = null,
) => {
  let queryRef = firestore.collection("ordersList");

  if (orderStatus !== "All Orders") {
    queryRef = queryRef.where("orderStatus", "==", orderStatus);
  }

  if (startTs != null && endTs != null) {
    queryRef = queryRef
      .where("createdAt", ">=", firebase.firestore.Timestamp.fromMillis(startTs))
      .where("createdAt", "<=", firebase.firestore.Timestamp.fromMillis(endTs));
  }

  queryRef = queryRef.orderBy("createdAt", "desc").limit(20);

  if (lastOrderId) {
    const lastSnap = await firestore.collection("ordersList").doc(lastOrderId).get();
    if (!lastSnap.exists) return { orders: [], lastVisible: null, hasMore: false };
    const lastData = lastSnap.data();
    if (!lastData || lastData.createdAt === undefined)
      throw new Error("Invalid last document: missing 'createdAt' field.");
    queryRef = queryRef.startAfter(lastData.createdAt);
  }

  try {
    const snapshot = await queryRef.get();
    const ordersArray = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    return {
      orders: ordersArray,
      lastVisible: snapshot.docs[snapshot.docs.length - 1]?.id || null,
      hasMore: snapshot.size > 0,
    };
  } catch (error) {
    console.error("Error fetching ordersList:", error);
    throw error;
  }
};

export const updateOrderInList = async (orderId) => {
  try {
    const snap = await firestore.collection("orders").doc(orderId).get();
    if (!snap.exists) return;
    const order = { id: snap.id, ...snap.data() };
    const stripped = stripOrderForList(order);
    await firestore.collection("ordersList").doc(orderId).set(stripped, { merge: true });
  } catch (error) {
    console.error("Error syncing ordersList:", error);
  }
};

export const migrateOrdersToOrdersList = async (onProgress, cutoffTs = null) => {
  let lastDoc = null;
  let totalMigrated = 0;
  const BATCH_SIZE = 20;

  while (true) {
    let queryRef = firestore
      .collection("orders")
      .orderBy("createdAt", "desc")
      .limit(BATCH_SIZE);
    // If resuming, only fetch orders older than the cutoff (already-migrated ones are newer)
    if (cutoffTs) queryRef = queryRef.where("createdAt", "<", cutoffTs);
    if (lastDoc) queryRef = queryRef.startAfter(lastDoc);

    const snapshot = await queryRef.get();
    if (snapshot.empty) break;

    const batch = firestore.batch();
    snapshot.docs.forEach((doc) => {
      const order = { id: doc.id, ...doc.data() };
      const stripped = stripOrderForList(order);
      batch.set(firestore.collection("ordersList").doc(doc.id), stripped, {
        merge: true,
      });
    });
    await batch.commit();

    totalMigrated += snapshot.docs.length;
    lastDoc = snapshot.docs[snapshot.docs.length - 1];
    if (onProgress) onProgress(totalMigrated);
    if (snapshot.docs.length < BATCH_SIZE) break;
  }

  return totalMigrated;
};

// Finds missing orders by comparing IDs within a time window (default last 7 days).
// Reads: orders_in_window + ordersList_in_window (both in parallel), writes only the missing ones.
export const syncNewOrdersToList = async (onProgress, daysBack = 2) => {
  const startTs = firebase.firestore.Timestamp.fromMillis(Date.now() - daysBack * 86400000);

  // Fetch both collections for the window in parallel
  const [ordersSnap, listSnap] = await Promise.all([
    firestore.collection("orders")
      .where("createdAt", ">=", startTs)
      .orderBy("createdAt", "asc")
      .get(),
    firestore.collection("ordersList")
      .where("createdAt", ">=", startTs)
      .orderBy("createdAt", "asc")
      .get(),
  ]);

  const listIds = new Set(listSnap.docs.map((d) => d.id));
  const missingDocs = ordersSnap.docs.filter((d) => !listIds.has(d.id));
  if (missingDocs.length === 0) return 0;

  const statusDelta = {};
  const dailyAccum = {};

  const missing = missingDocs.map((d) => {
    const order = { id: d.id, ...d.data() };
    const stripped = stripOrderForList(order);
    const totalBill = (order.subTotal || 0) + (order.deliveryCharge || 0)
      - (order.discountApplied || 0)
      - (order.couponApplied ? order.couponApplied.discount || 0 : 0)
      - (order.finalDiscount || 0);
    const totalPaid = (order.payments || []).reduce((s, p) => s + (parseInt(p.amount) || 0), 0);
    stripped.totalBill = totalBill;
    stripped.totalPaid = totalPaid;

    const st = order.orderStatus || "";
    if (st) {
      statusDelta[`${st}.count`]         = (statusDelta[`${st}.count`]         || 0) + 1;
      statusDelta[`${st}.totalBill`]     = (statusDelta[`${st}.totalBill`]     || 0) + totalBill;
      statusDelta[`${st}.totalPaid`]     = (statusDelta[`${st}.totalPaid`]     || 0) + totalPaid;
      statusDelta[`${st}.totalDiscount`] = (statusDelta[`${st}.totalDiscount`] || 0) + (order.finalDiscount || 0);
    }

    const dRef = dayDocRef(order.createdAt);
    if (dRef) {
      const path = dRef.path;
      if (!dailyAccum[path]) dailyAccum[path] = { ref: dRef, count: 0, totalBill: 0, totalPaid: 0, totalDiscount: 0, cancelledCount: 0, cancelledBill: 0 };
      if (st === "Cancelled") {
        dailyAccum[path].cancelledCount += 1;
        dailyAccum[path].cancelledBill  += totalBill;
      } else {
        dailyAccum[path].count         += 1;
        dailyAccum[path].totalBill     += totalBill;
        dailyAccum[path].totalPaid     += totalPaid;
        dailyAccum[path].totalDiscount += (order.finalDiscount || 0);
      }
    }

    return { id: order.id, stripped };
  });

  // Write missing ordersList docs in batches of 20
  const BATCH_SIZE = 20;
  for (let i = 0; i < missing.length; i += BATCH_SIZE) {
    const batch = firestore.batch();
    missing.slice(i, i + BATCH_SIZE).forEach(({ id, stripped }) => {
      batch.set(firestore.collection("ordersList").doc(id), stripped, { merge: true });
    });
    await batch.commit();
    if (onProgress) onProgress(Math.min(i + BATCH_SIZE, missing.length));
  }

  // Update summaries
  const summaryBatch = firestore.batch();
  const summaryUpdate = {};
  Object.entries(statusDelta).forEach(([k, v]) => { summaryUpdate[k] = inc(v); });
  if (Object.keys(summaryUpdate).length > 0) summaryBatch.update(SUMMARY_DOC(), summaryUpdate);
  Object.values(dailyAccum).forEach(({ ref, ...nums }) => {
    const d = {};
    Object.entries(nums).forEach(([k, v]) => { if (v !== 0) d[k] = inc(v); });
    if (Object.keys(d).length > 0) summaryBatch.set(ref, d, { merge: true });
  });
  await summaryBatch.commit();

  return missing.length;
};

// ───────────────────────────────────────────────────────────────────────────

export const getRecentOrders = async (count = 5, startTs = null, endTs = null) => {
  try {
    let queryRef = firestore.collection("ordersList");
    if (startTs != null && endTs != null) {
      queryRef = queryRef
        .where("createdAt", ">=", firebase.firestore.Timestamp.fromMillis(startTs))
        .where("createdAt", "<=", firebase.firestore.Timestamp.fromMillis(endTs));
    }
    const snapshot = await queryRef.orderBy("createdAt", "desc").limit(count).get();
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error fetching recent orders:", error);
    return [];
  }
};

export const updateAllUsers = async () => {
  const collection = await firestore.collection("users").get();
  collection.forEach((doc) => {
    doc.ref.update({
      ...doc.data(),
      imageUrl:
        "https://firebasestorage.googleapis.com/v0/b/globalbuybd-auth.appspot.com/o/users%2Fprofile.png?alt=media&token=810e25f1-8cd9-43b0-b49d-41f2236588cb",
    });
  });
};

export const deleteOrder = async (id) => {
  const orderRef = firestore.doc(`orders/${id}`);
  try {
    await orderRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getSingleOrder = async (id) => {
  const orderRef = firestore.doc(`orders/${id}`);
  try {
    const order = await orderRef.get();
    return order.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getSingleCampaign = async (id) => {
  const orderRef = firestore.doc(`campaigns/${id}`);
  try {
    const order = await orderRef.get();
    return order.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getSingleAttribute = async (id) => {
  const orderRef = firestore.doc(`attributes/${id}`);
  try {
    const order = await orderRef.get();
    return order.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

const SUMMARY_DOC = () => firestore.doc("summaries/orderStatsByStatus");
const inc = (n) => firebase.firestore.FieldValue.increment(n);

const buildSummaryDelta = (old, updated) => {
  const oldStatus = old.orderStatus || "";
  const newStatus = updated.orderStatus || oldStatus;
  // Accumulate as plain numbers first, keyed by "<status>.<field>" — when
  // oldStatus === newStatus (the common case: editing an order without
  // changing its status), the old.field:contributes/new.field:contributes
  // both land on the SAME key and must net together (e.g. count: -1 + 1 = 0)
  // rather than the second FieldValue.increment() sentinel silently
  // overwriting the first, which was inflating every status bucket's count
  // and totals on every single edit regardless of whether status changed.
  const numeric = {};
  const add = (status, field, amount) => {
    if (!status || !amount) return;
    const key = `${status}.${field}`;
    numeric[key] = (numeric[key] || 0) + amount;
  };
  if (oldStatus) {
    add(oldStatus, "count", -1);
    add(oldStatus, "totalBill", -(old.totalBill || 0));
    add(oldStatus, "totalPaid", -(old.totalPaid || 0));
    add(oldStatus, "totalDiscount", -(old.finalDiscount || 0));
  }
  if (newStatus) {
    add(newStatus, "count", 1);
    add(newStatus, "totalBill", updated.totalBill || 0);
    add(newStatus, "totalPaid", updated.totalPaid || 0);
    add(newStatus, "totalDiscount", updated.finalDiscount || 0);
  }
  const delta = {};
  Object.entries(numeric).forEach(([key, value]) => {
    if (value !== 0) delta[key] = inc(value);
  });
  return delta;
};

// Daily summary helpers — one doc per calendar day in summaries/orderStats_YYYY_MM_DD
const dayDocRef = (createdAt) => {
  if (!createdAt) return null;
  const d = createdAt.toDate ? createdAt.toDate() : new Date(Number(createdAt));
  const y  = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const dy = String(d.getDate()).padStart(2, "0");
  return firestore.doc(`summaries/orderStats_${y}_${mo}_${dy}`);
};

const getDayKeys = (startTs, endTs) => {
  const keys = [];
  const d = new Date(startTs);
  d.setHours(0, 0, 0, 0);
  const end = new Date(endTs);
  while (d <= end) {
    keys.push(
      `orderStats_${d.getFullYear()}_${String(d.getMonth()+1).padStart(2,"0")}_${String(d.getDate()).padStart(2,"0")}`
    );
    d.setDate(d.getDate() + 1);
  }
  return keys;
};

// Computes flat numeric delta for a daily doc when an order's list fields change
const buildDailyDocDelta = (old, updated) => {
  const n = { count: 0, totalBill: 0, totalPaid: 0, totalDiscount: 0, cancelledCount: 0, cancelledBill: 0 };
  const oldCancelled = old.orderStatus === "Cancelled";
  const newCancelled = updated.orderStatus === "Cancelled";
  if (oldCancelled) { n.cancelledCount -= 1; n.cancelledBill -= (old.totalBill     || 0); }
  else              { n.count -= 1; n.totalBill -= (old.totalBill || 0); n.totalPaid -= (old.totalPaid || 0); n.totalDiscount -= (old.finalDiscount || 0); }
  if (newCancelled) { n.cancelledCount += 1; n.cancelledBill += (updated.totalBill     || 0); }
  else              { n.count += 1; n.totalBill += (updated.totalBill || 0); n.totalPaid += (updated.totalPaid || 0); n.totalDiscount += (updated.finalDiscount || 0); }
  const delta = {};
  Object.entries(n).forEach(([k, v]) => { if (v !== 0) delta[k] = inc(v); });
  return delta;
};

// Monthly sourcing stats — one doc per month in sourcingMonthStats/{month},
// incrementally updated by every function that touches a sourcing invoice's
// financial fields (see uploadSourcing/updateSourcing/deleteSourcing/
// handleSourcingCashIn/handleSourcingCashOut/handleSourcingAgentPay).
const monthStatsRef = (month) => firestore.doc(`sourcingMonthStats/${month}`);

// Builds a nested delta object (not dotted-string keys) since `agent` is a
// free-text employee name and can contain characters like "." that Firestore
// would otherwise parse as a field-path separator in an object key.
const buildMonthStatsDelta = (agent, deltas) => {
  const flat = {};
  const byAgent = {};
  Object.entries(deltas).forEach(([key, value]) => {
    if (!value) return;
    flat[key] = inc(value);
    if (agent) byAgent[key] = inc(value);
  });
  return agent && Object.keys(byAgent).length > 0
    ? { ...flat, byAgent: { [agent]: byAgent } }
    : flat;
};

const sumRefundArray = (arr) =>
  (arr || []).reduce((sum, r) => sum + (parseFloat(r.amount) || 0), 0);

const pickListFields = (data) => {
  const fields = {};
  ["orderStatus", "orderNote", "subTotal", "deliveryCharge",
    "discountApplied", "finalDiscount", "payments", "paymentStatus",
    "refundedAmount"].forEach((f) => {
    if (data[f] !== undefined) fields[f] = data[f];
  });
  if (data.couponApplied !== undefined) {
    fields.couponApplied = data.couponApplied
      ? { discount: data.couponApplied.discount || 0 }
      : null;
  }
  if (data.courier !== undefined) {
    fields.courier = data.courier
      ? {
          pathao: data.courier.pathao || null,
          consignment: data.courier.consignment
            ? {
                consignment_id: data.courier.consignment.consignment_id || null,
                status: data.courier.consignment.status || null,
              }
            : null,
          consignment_id: data.courier.consignment_id || null,
        }
      : null;
  }
  if (data.currentUser !== undefined) {
    fields.currentUser = {
      displayName: (data.currentUser && data.currentUser.displayName) || "Guest",
    };
  }
  if (data.deliveryAddress !== undefined) {
    fields.deliveryAddress = data.deliveryAddress;
  }
  if (data.orders !== undefined) {
    fields.orders = (data.orders || []).map((item) => ({
      name: (item.product && item.product.name) || item.name || "",
      image:
        item.productImage ||
        item.selectedVariation?.pictures?.[0] ||
        item.product?.pictures?.[0] ||
        "",
      quantity: item.quantity || 1,
    }));
  }
  // Recompute totalPaid whenever payments array is present in the update
  if (data.payments !== undefined) {
    fields.totalPaid = (data.payments || []).reduce(
      (s, p) => s + (parseInt(p.amount) || 0),
      0,
    );
  }
  // Recompute totalBill when all components are available (full orderObj path)
  const billKeys = ["subTotal", "deliveryCharge", "discountApplied", "finalDiscount"];
  if (billKeys.every((k) => data[k] !== undefined)) {
    fields.totalBill =
      (data.subTotal || 0) +
      (data.deliveryCharge || 0) -
      (data.discountApplied || 0) -
      (data.couponApplied ? data.couponApplied.discount || 0 : 0) -
      (data.finalDiscount || 0);
  }
  return fields;
};

export const updateOrder = async (orderObj) => {
  const orderRef = firestore.doc(`orders/${orderObj.id}`);
  const listRef  = firestore.doc(`ordersList/${orderObj.id}`);
  const listFields = pickListFields(orderObj);
  const oldSnap = await listRef.get();
  const old = oldSnap.data() || {};
  const updated = { ...old, ...listFields };
  const batch = firestore.batch();
  batch.update(orderRef, orderObj);
  if (Object.keys(listFields).length > 0) {
    batch.set(listRef, listFields, { merge: true });
    try { batch.update(SUMMARY_DOC(), buildSummaryDelta(old, updated)); } catch (_) {}
    const dRef = dayDocRef(old.createdAt);
    if (dRef) {
      const dailyDelta = buildDailyDocDelta(old, updated);
      if (Object.keys(dailyDelta).length > 0) batch.set(dRef, dailyDelta, { merge: true });
    }
  }
  await batch.commit();
  const updatedSnapshot = await orderRef.get();
  return updatedSnapshot.data();
};

// Atomic batch: update multiple orders (payments only) + create cash-in entries + one expense entry.
// All writes succeed or all fail together.
// `ordersToUpdate` items: { updatedOrder, patch, dedupe, cashIn }
//   - updatedOrder: full in-memory order (used only to compute pickListFields/summary deltas, never written as-is)
//   - patch: small object actually written to orders/{id}
//   - dedupe: { type: "payment", transactionId } | { type: "orderStatus", value } — used to detect
//     and skip consignments whose effect was already applied by an earlier, partially-committed attempt
//   - cashIn: optional dailyCashIn doc to write alongside this order (omitted for cancel-only items)
export const applyPaymentBatch = async ({ ordersToUpdate, expense }) => {
  // Pre-read ordersList docs — used both for summary/daily deltas and as the
  // idempotency source of truth (see dedupe below).
  const listSnaps = await Promise.all(
    ordersToUpdate.map(({ updatedOrder }) =>
      firestore.doc(`ordersList/${updatedOrder.id}`).get()
    )
  );

  // Aggregate numeric deltas to avoid multiple batch.update() calls on the same doc
  const summaryNum = {};
  const dailyNums = {};

  // Collect all writes as plain ops first — Firestore caps a single batch at
  // 500 writes AND ~10MB total payload, and a large Steadfast payment (200+
  // consignments) needs ~3 writes per consignment (orders + ordersList +
  // dailyCashIn), so it must be split across multiple batches instead of one.
  const ops = [];
  let appliedCount = 0;
  let skippedCount = 0;

  ordersToUpdate.forEach(({ updatedOrder, patch, dedupe, cashIn }, i) => {
    const old = listSnaps[i].data() || {};

    // Idempotency guard: if a prior attempt already committed this exact
    // consignment's effect (e.g. a chunk succeeded, then a later chunk failed
    // and the admin retried with a stale client-side preview), skip it
    // entirely rather than re-appending a duplicate payment or re-writing an
    // already-correct orderStatus. This is checked against live Firestore
    // data (listSnaps), not client state, so it's safe regardless of *why*
    // the retry happened.
    if (dedupe) {
      if (dedupe.type === "payment") {
        const already = (old.payments || []).some(
          (p) => String(p.transactionId) === String(dedupe.transactionId)
        );
        if (already) { skippedCount++; return; }
      }
      if (dedupe.type === "orderStatus" && old.orderStatus === dedupe.value) {
        skippedCount++; return;
      }
    }
    appliedCount++;

    const listFields = pickListFields(updatedOrder);
    const status = old.orderStatus || updatedOrder.orderStatus || "";
    const newTotalPaid = listFields.totalPaid !== undefined ? listFields.totalPaid : (old.totalPaid || 0);
    const paidDelta = newTotalPaid - (old.totalPaid || 0);
    if (status && paidDelta !== 0) {
      summaryNum[`${status}.totalPaid`] = (summaryNum[`${status}.totalPaid`] || 0) + paidDelta;
    }
    const dRef = dayDocRef(old.createdAt);
    if (dRef && paidDelta !== 0) {
      const key = dRef.path;
      if (!dailyNums[key]) dailyNums[key] = { ref: dRef, totalPaid: 0 };
      dailyNums[key].totalPaid += paidDelta;
    }

    // Only write the fields that actually changed — sending the full order
    // back (product data, images, addresses, etc.) for every consignment is
    // what blows past Firestore's 10MB per-request payload limit on large
    // payments.
    ops.push({ type: "update", ref: firestore.doc(`orders/${updatedOrder.id}`), data: patch || updatedOrder });
    if (Object.keys(listFields).length > 0) {
      ops.push({ type: "set", ref: firestore.doc(`ordersList/${updatedOrder.id}`), data: listFields, options: { merge: true } });
    }
    if (cashIn) {
      ops.push({ type: "set", ref: firestore.doc(`dailyCashIn/${cashIn.id}`), data: cashIn });
    }
  });

  const summaryUpdate = {};
  Object.entries(summaryNum).forEach(([k, v]) => { if (v !== 0) summaryUpdate[k] = inc(v); });
  if (Object.keys(summaryUpdate).length > 0) {
    try { ops.push({ type: "update", ref: SUMMARY_DOC(), data: summaryUpdate }); } catch (_) {}
  }

  Object.values(dailyNums).forEach(({ ref, totalPaid }) => {
    if (totalPaid !== 0) ops.push({ type: "set", ref, data: { totalPaid: inc(totalPaid) }, options: { merge: true } });
  });

  ops.push({ type: "set", ref: firestore.doc(`dailyExpenses/${expense.id}`), data: expense });

  // Chunk on whichever limit hits first — op count (Firestore's hard 500 cap)
  // or estimated byte size (Firestore's ~10MB per-request cap). Byte size is
  // measured in actual UTF-8 bytes via TextEncoder, not JS string `.length`
  // (UTF-16 code units) — this app routinely has Bengali text in customer
  // names/addresses/notes, which encodes to ~3 bytes per character in UTF-8
  // but only counts as 1 toward `.length`, so `.length`-based estimates can
  // undercount the real wire payload by up to ~3x. Thresholds are kept well
  // under Firestore's hard limits to leave headroom for protobuf/index
  // overhead beyond raw JSON bytes.
  const MAX_OPS_PER_CHUNK = 250;
  const MAX_BYTES_PER_CHUNK = 4 * 1024 * 1024; // 4MB
  const textEncoder = new TextEncoder();
  const estimateBytes = (data) => {
    try { return textEncoder.encode(JSON.stringify(data)).length; } catch (_) { return 0; }
  };

  const chunks = [];
  let current = [];
  let currentBytes = 0;
  ops.forEach((op) => {
    const size = estimateBytes(op.data);
    if (current.length > 0 && (current.length >= MAX_OPS_PER_CHUNK || currentBytes + size > MAX_BYTES_PER_CHUNK)) {
      chunks.push(current);
      current = [];
      currentBytes = 0;
    }
    current.push(op);
    currentBytes += size;
  });
  if (current.length > 0) chunks.push(current);

  for (const chunkOps of chunks) {
    const batch = firestore.batch();
    chunkOps.forEach((op) => {
      if (op.type === "update") batch.update(op.ref, op.data);
      else batch.set(op.ref, op.data, op.options);
    });
    await batch.commit();
  }

  return { appliedCount, skippedCount };
};

export const updateMultipleOrder = async (ids, orderStatus) =>
  bulkUpdateOrderStatus(ids, orderStatus);

export const updateMultipleOrderwithOrderTo = async (ids, orderStatus, orderTo) => {
  const oldSnaps = await Promise.all(ids.map((id) => firestore.doc(`ordersList/${id}`).get()));
  const batch = firestore.batch();
  const numDelta = {};
  const dailyNumDeltas = {};

  ids.forEach((id, i) => {
    batch.update(firestore.doc(`orders/${id}`), { orderStatus, orderTo });
    batch.set(firestore.doc(`ordersList/${id}`), { orderStatus }, { merge: true });

    const old = oldSnaps[i].data() || {};
    const oldStatus = old.orderStatus || "";
    const bill = old.totalBill || 0, paid = old.totalPaid || 0, disc = old.finalDiscount || 0;

    if (oldStatus && oldStatus !== orderStatus) {
      numDelta[`${oldStatus}.count`]         = (numDelta[`${oldStatus}.count`]         || 0) - 1;
      numDelta[`${oldStatus}.totalBill`]     = (numDelta[`${oldStatus}.totalBill`]     || 0) - bill;
      numDelta[`${oldStatus}.totalPaid`]     = (numDelta[`${oldStatus}.totalPaid`]     || 0) - paid;
      numDelta[`${oldStatus}.totalDiscount`] = (numDelta[`${oldStatus}.totalDiscount`] || 0) - disc;
    }
    numDelta[`${orderStatus}.count`]         = (numDelta[`${orderStatus}.count`]         || 0) + 1;
    numDelta[`${orderStatus}.totalBill`]     = (numDelta[`${orderStatus}.totalBill`]     || 0) + bill;
    numDelta[`${orderStatus}.totalPaid`]     = (numDelta[`${orderStatus}.totalPaid`]     || 0) + paid;
    numDelta[`${orderStatus}.totalDiscount`] = (numDelta[`${orderStatus}.totalDiscount`] || 0) + disc;

    const dRef = dayDocRef(old.createdAt);
    if (dRef) {
      const path = dRef.path;
      if (!dailyNumDeltas[path]) dailyNumDeltas[path] = { ref: dRef, n: { count: 0, totalBill: 0, totalPaid: 0, totalDiscount: 0, cancelledCount: 0, cancelledBill: 0 } };
      const nd = dailyNumDeltas[path].n;
      const oldCancelled = oldStatus === "Cancelled";
      const newCancelled = orderStatus === "Cancelled";
      if (oldCancelled) { nd.cancelledCount -= 1; nd.cancelledBill -= bill; }
      else              { nd.count -= 1; nd.totalBill -= bill; nd.totalPaid -= paid; nd.totalDiscount -= disc; }
      if (newCancelled) { nd.cancelledCount += 1; nd.cancelledBill += bill; }
      else              { nd.count += 1; nd.totalBill += bill; nd.totalPaid += paid; nd.totalDiscount += disc; }
    }
  });

  const summaryUpdate = {};
  Object.entries(numDelta).forEach(([k, v]) => { summaryUpdate[k] = inc(v); });
  try { batch.update(SUMMARY_DOC(), summaryUpdate); } catch (_) {}

  Object.values(dailyNumDeltas).forEach(({ ref, n }) => {
    const delta = {};
    Object.entries(n).forEach(([k, v]) => { if (v !== 0) delta[k] = inc(v); });
    if (Object.keys(delta).length > 0) batch.set(ref, delta, { merge: true });
  });

  await batch.commit();
};

// paymet management
export const getAllPayments = async () => {
  const paymentsCollectionRef = firestore.collection("payments");
  try {
    const payments = await paymentsCollectionRef.get();
    const paymentsArray = [];
    payments.forEach((doc) => {
      paymentsArray.push({ uid: doc.id, ...doc.data() });
    });
    return paymentsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deletePayment = async (orderId) => {
  const paymentRef = firestore.doc(`payments/${orderId}`);
  try {
    await paymentRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const updatePaymentStatus = async (paymentObj) => {
  const paymentRef = firestore.doc(`payments/${paymentObj.orderId}`);
  const payment = await paymentRef.get();
  var actualPayment = payment
    .data()
    .payments.find((payment) => payment.paymentId == paymentObj.paymentId);
  const orderId = actualPayment.orderId;
  const orderRef = firestore.doc(`orders/${orderId}`);
  const order = await orderRef.get();
  const userId = await order.data().userId;
  const userRef = firestore.doc(`users/${userId}`);
  const user = await userRef.get();
  var exactPayment = user
    .data()
    .paymentsArray.find((payment) => payment.paymentId == paymentObj.paymentId);
  exactPayment.paymentStatus = paymentObj.paymentStatus;
  var otherPayments = user
    .data()
    .paymentsArray.filter(
      (payment) => payment.paymentId !== paymentObj.paymentId,
    );

  await userRef.update({ paymentsArray: [exactPayment, ...otherPayments] });
  const updatedPaymentObj = payment
    .data()
    .payments.find((payment) => payment.paymentId == paymentObj.paymentId);
  updatedPaymentObj.paymentStatus = paymentObj.paymentStatus;
  const newPaymentsArray = payment
    .data()
    .payments.filter((payment) => payment.paymentId !== paymentObj.paymentId);
  try {
    await paymentRef.update({
      ...payment.data(),
      payments: [...newPaymentsArray, updatedPaymentObj],
    });
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const updateOrderAmount = async (paymentObj) => {
  try {
    const orderRef = firestore.doc(`orders/${paymentObj.orderId}`);
    const order = await orderRef.get();
    const newPaymentStatus = {
      ...order.data().paymentStatus,
      due:
        parseInt(order.data().paymentStatus.total) -
        (parseInt(order.data().paymentStatus.paid) + parseInt(paymentObj.amount)),
      paid:
        parseInt(order.data().paymentStatus.paid) + parseInt(paymentObj.amount),
    };
    const updateData = {
      ...order.data(),
      status:
        order.data().status === "order_pending"
          ? "payment_approved"
          : order.data().status,
      paymentStatus: newPaymentStatus,
    };
    const listSnap = await firestore.doc(`ordersList/${paymentObj.orderId}`).get();
    const listData = listSnap.data() || {};
    const currentStatus = listData.orderStatus || "Processing";
    const oldTotalPaid = listData.totalPaid || 0;
    const newTotalPaid = parseInt(newPaymentStatus.paid) || 0;
    const deltaPaid = newTotalPaid - oldTotalPaid;
    const batch = firestore.batch();
    batch.update(orderRef, updateData);
    batch.set(
      firestore.doc(`ordersList/${paymentObj.orderId}`),
      { paymentStatus: newPaymentStatus, totalPaid: newTotalPaid },
      { merge: true },
    );
    try { batch.update(SUMMARY_DOC(), { [`${currentStatus}.totalPaid`]: inc(deltaPaid) }); } catch (_) {}
    if (currentStatus !== "Cancelled") {
      const dRef = dayDocRef(listData.createdAt);
      if (dRef) batch.set(dRef, { totalPaid: inc(deltaPaid) }, { merge: true });
    }
    await batch.commit();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

// distribute order to managers
export const orderProductsFromChina = async (orderIdArray, orderTo) => {
  const adminsCollectionRef = firestore.collection("admins");
  orderIdArray.forEach(async (orderId) => {
    const orderRef = firestore.doc(`orders/${orderId}`);
    try {
      const order = await orderRef.get();
      if (!order.data().orderTo) {
        try {
          const admins = await adminsCollectionRef.get();
          admins.forEach((doc) => {
            var adminRef = firestore.doc(`admins/${doc.id}`);
            if (doc.data().name == orderTo) {
              adminRef.update({
                ...doc.data(),
                pending_orders: [...doc.data().pending_orders, orderId],
              });
              return;
            }
          });
        } catch (error) {
          notifyError(error.message || String(error));
        }
      } else {
        console.log(
          `${orderId} is already ordered to another supplier.check ordered item`,
        );
      }
    } catch (error) {
      console.log(error);
    }
  });
};

export const productToOrder = async (productsArray) => {
  productsArray.forEach((product) => {
    const productToOrderRef = firestore.doc(`productToOrder/${product.id}`);
    try {
      productToOrderRef.set(product);
    } catch (error) {
      notifyError(error.message || String(error));
    }
  });
};

// admins
export const getAllAdmins = async () => {
  const adminsCollectionRef = firestore.collection("admins");
  try {
    const admins = await adminsCollectionRef.get();
    const adminsArray = [];
    admins.forEach((doc) => {
      adminsArray.push({ adminId: doc.id, ...doc.data() });
    });
    return adminsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const rechargeAdmin = async (adminIdArray, balance) => {
  adminIdArray.forEach(async (adminId) => {
    const adminRef = firestore.doc(`admins/${adminId}`);
    try {
      const admin = await adminRef.get();
      var total_balance = parseInt(admin.data().balance) + parseInt(balance);
      await adminRef.update({
        ...admin.data(),
        balance: admin.data().balance
          ? parseInt(admin.data().balance) + parseInt(balance)
          : parseInt(balance),
        remaining_balance: total_balance - parseInt(admin.data().used_balance),
      });
    } catch (error) {
      notifyError(error.message || String(error));
    }
  });
};

export const updateProfileImage = async (imgUrl, id) => {
  const adminRef = firestore.doc(`admins/${id}`);
  try {
    const admin = await adminRef.get();
    await adminRef.update({ ...admin.data(), image: imgUrl });
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const setRmbPrice = async (taka) => {
  const currencyRef = firestore.doc(`Currency/taka`);
  let rmbRate;
  if (taka) {
    try {
      const currency = await currencyRef.get();
      if (currency.data()) {
        await currencyRef.update({ ...currency.data(), taka });
        rmbRate = taka;
        return rmbRate;
      } else {
        await currencyRef.set({ taka: taka });
        rmbRate = taka;
        return rmbRate;
      }
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    try {
      const currency = await currencyRef.get();
      rmbRate = currency.data().taka;
      return rmbRate;
    } catch (error) {
      notifyError(error.message || String(error));
    }
  }
};

export const getAllProductRequests = async (status) => {
  const reqeustsCollectionRef = firestore
    .collection("bookingRequest")
    .where("status", "==", status);

  try {
    const requests = await reqeustsCollectionRef.get();
    const requestsArray = [];
    requests.forEach((doc) => {
      requestsArray.push(doc.data());
    });
    return requestsArray.sort((a, b) => b.time - a.time);
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getAllShipmentRequests = async (status) => {
  const reqeustsCollectionRef = firestore
    .collection("shipForMe")
    .where("status", "==", status);

  try {
    const requests = await reqeustsCollectionRef.get();
    const requestsArray = [];
    requests.forEach((doc) => {
      requestsArray.push(doc.data());
    });
    return requestsArray.sort((a, b) => b.time - a.time);
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const updateProductRequest = async (requestObj) => {
  const reqeustRef = firestore.doc(`bookingRequest/${requestObj.bookingId}`);

  try {
    await reqeustRef.update({
      ...requestObj,
    });
    const request = await reqeustRef.get();
    return request.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const updateProduct = async (productObj) => {
  const productRef = firestore.doc(`aliproducts/${productObj.id}`);

  try {
    await productRef.update({
      ...productObj,
    });
    const product = await productRef.get();
    return product.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const updateProductInventory = async (productObj) => {
  const productRef = firestore.doc(`products/${productObj.productId}`);
  let product = await productRef.get();
  console.log(product.data());
  console.log(productObj);
  try {
    if (productObj.selectedVariation) {
      await productRef.update({
        displayedVariations: product
          .data()
          .displayedVariations.map((variation) => {
            if (variation.id == productObj.selectedVariation.id) {
              console.log(variation.id);
              console.log(productObj.selectedVariation.id);
              return {
                ...variation,
                inventory:
                  parseInt(variation.inventory) - parseInt(productObj.quantity),
              };
            } else {
              return variation;
            }
          }),
      });
    } else {
      await productRef.update({
        inventory: product.data().inventory
          ? product.data().inventory - productObj.quantity
          : 0,
      });
    }

    const updated = await productRef.get();
    if (updated.exists) {
      try {
        await firestore
          .collection("productList")
          .doc(productObj.productId)
          .set(
            stripProductForList({ id: productObj.productId, ...updated.data() }),
            { merge: true },
          );
      } catch (e) {
        console.error("productList sync failed", e);
      }
    }
    return product.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const updateReview = async (reviewObj) => {
  const productRef = firestore.doc(`products/${reviewObj.productId}`);
  const product = await productRef.get();

  try {
    await productRef.update({
      ...product.data(),
      reviews: product.data().reviews.map((review) => {
        if (review.id == reviewObj.id) {
          return reviewObj;
        } else {
          return review;
        }
      }),
    });
    const updatedProduct = await productRef.get();
    return updatedProduct.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const updateShipmentRequest = async (requestObj) => {
  const reqeustRef = firestore.doc(`shipForMe/${requestObj.bookingId}`);

  try {
    await reqeustRef.update({
      ...requestObj,
    });
    const request = await reqeustRef.get();
    return request.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllPaymentRequest = async () => {
  const paymentRequestCollectionRef = firestore
    .collection("paymentRequest")
    .where("status", "==", "pending");

  try {
    const paymentRequest = await paymentRequestCollectionRef.get();
    const paymentRequestArray = [];
    paymentRequest.forEach((doc) => {
      paymentRequestArray.push(doc.data());
    });
    console.log(paymentRequestArray);
    return paymentRequestArray.sort((a, b) => b.time - a.time);
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getAllPaymentRequestOrder = async () => {
  const paymentRequestCollectionRef = firestore
    .collection("paymentRequestApi")
    .where("status", "==", "pending");

  try {
    const paymentRequest = await paymentRequestCollectionRef.get();
    const paymentRequestArray = [];
    paymentRequest.forEach((doc) => {
      paymentRequestArray.push(doc.data());
    });
    console.log(paymentRequestArray);
    return paymentRequestArray.sort((a, b) => b.time - a.time);
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const updatePaymentRequestStatus = async (paymentRequestObj) => {
  console.log(paymentRequestObj);
  const paymentRequestRef = firestore.doc(
    `paymentRequest/${paymentRequestObj.paymentId}`,
  );
  const snapshot = await paymentRequestRef.get();
  if (snapshot.exists) {
    try {
      paymentRequestObj.productRequestArray.forEach(async (productRequest) => {
        if (productRequest.shipFrom) {
          const bookingRequestRef = firestore.doc(
            `shipForMe/${productRequest.bookingId}`,
          );
          const bookingRequest = await bookingRequestRef.get();
          await bookingRequestRef.update({
            paymentStatus: paymentRequestObj.status,
            status:
              paymentRequestObj.status === "paid"
                ? "Paid"
                : bookingRequest.data().status,
          });
        } else {
          const bookingRequestRef = firestore.doc(
            `bookingRequest/${productRequest.bookingId}`,
          );
          const bookingRequest = await bookingRequestRef.get();
          await bookingRequestRef.update({
            paymentStatus: paymentRequestObj.status,
            status:
              paymentRequestObj.status === "paid"
                ? "Paid"
                : bookingRequest.data().status,
          });
        }
      });
      await paymentRequestRef.update({
        status: paymentRequestObj.status,
      });
      const updatedPaymentRequestObj = await paymentRequestRef.get();
      return updatedPaymentRequestObj.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    return null;
  }
};
export const updatePaymentRequestOrderStatus = async (paymentRequestObj) => {
  console.log(paymentRequestObj);
  const paymentRequestRef = firestore.doc(
    `paymentRequestApi/${paymentRequestObj.paymentId}`,
  );
  const snapshot = await paymentRequestRef.get();
  if (snapshot.exists) {
    try {
      for (let i = 0; i < paymentRequestObj.pendingOrders.length; i++) {
        const element = paymentRequestObj.pendingOrders[i];
        const orderRef = firestore.doc(`ordersApi/${element.orderId}`);

        const order = await orderRef.get();
        await orderRef.update({
          orderStatus: paymentRequestObj.status,
          paymentStatus:
            paymentRequestObj.status == "approved"
              ? "paid"
              : paymentRequestObj.status,
        });
      }
      await paymentRequestRef.update({
        status: paymentRequestObj.status,
      });
      const updatedPaymentRequestObj = await paymentRequestRef.get();
      return updatedPaymentRequestObj.data();
    } catch (error) {
      notifyError(error.message || String(error));
      return null;
    }
  } else {
    return null;
  }
};

const normalizeOrderApiDoc = (data) => {
  if (!data) return data;
  const tsMs = data.createdAt
    ? data.createdAt.toMillis()
    : data.createdAt
      ? data.createdAt.toMillis()
      : data.date
        ? parseInt(data.date)
        : data.time || 0;
  const orderedDate =
    data.orderedDate ||
    (data.createdAt
      ? data.createdAt.toDate().toLocaleDateString("en-GB")
      : data.createdAt
        ? data.createdAt.toDate().toLocaleDateString("en-GB")
        : "");
  return {
    ...data,
    orderStatus: data.orderStatus || "",
    orderTotal:
      data.orderTotal !== undefined
        ? data.orderTotal
        : data.subTotal || data.total || 0,
    localShipping:
      data.localShipping !== undefined
        ? data.localShipping
        : data.deliveryCharge || 0,
    time: data.time || tsMs,
    orderedDate,
    deliveryAddress:
      data.deliveryAddress ||
      (data.shippingAddress
        ? {
            name:
              data.shippingAddress.fullName || data.shippingAddress.name || "",
            mobileNo: data.shippingAddress.mobileNo || "",
            address: data.shippingAddress.address || "",
            district: data.shippingAddress.district || "",
            division: data.shippingAddress.division || "",
          }
        : null),
  };
};

export const getAllOrdersApi = async (orderStatus, startDate, endDate) => {
  let ordersCollectionRef;

  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);
  const end = new Date(endDate);
  end.setHours(23, 59, 59, 999);
  const startTs = firebase.firestore.Timestamp.fromDate(start);
  const endTs = firebase.firestore.Timestamp.fromDate(end);

  if (orderStatus === "Picked") {
    console.log("fetching picked orders");
    ordersCollectionRef = firestore
      .collection("ordersApi")
      .where("agentStatus", "==", "Picked")
      .where("orderStatus", "==", "pending")
      .where("createdAt", ">=", startTs)
      .where("createdAt", "<=", endTs);
  } else if (orderStatus === "") {
    console.log("fetching all orders");
    ordersCollectionRef = firestore
      .collection("ordersApi")
      .where("createdAt", ">=", startTs)
      .where("createdAt", "<=", endTs);
  } else {
    console.log(`fetching ${orderStatus} orders`);
    ordersCollectionRef = firestore
      .collection("ordersApi")
      .where("orderStatus", "==", orderStatus)
      .where("createdAt", ">=", startTs)
      .where("createdAt", "<=", endTs);
  }

  try {
    const orders = await ordersCollectionRef.get();
    const ordersArray = [];
    orders.forEach((doc) => {
      ordersArray.push(normalizeOrderApiDoc(doc.data()));
    });
    return ordersArray;
  } catch (error) {
    console.error("getAllOrdersApi error:", error);
    notifyError(error.message || String(error));
    return [];
  }
};

export const updateAllOrdersApi = () => {
  firestore
    .collection("ordersApi")
    .get()
    .then((snapshot) => {
      snapshot.forEach((doc) => {
        doc.ref.update({
          createdAt: firebase.firestore.Timestamp.fromMillis(doc.data().time),
        });
      });
    });
};

export const updateOrdersWithTrackingNo = async (orders) => {
  try {
    const batch = firebase.firestore().batch();
    orders.forEach((order) => {
      const orderRef = firebase
        .firestore()
        .collection("ordersApi")
        .doc(`${order.orderId}`);
      batch.update(orderRef, { trackingNo: order.trackingNo });
    });
    await batch.commit();
    return orders;
  } catch (err) {
    console.log(err);
    return [];
  }
};
export const getAllRooms = async () => {
  const roomsCollectionRef = firestore.collection("rooms");

  try {
    const rooms = await roomsCollectionRef.get();
    const roomsArray = [];
    rooms.forEach((doc) => {
      roomsArray.push(doc.data());
    });
    return roomsArray.sort((a, b) => b.time - a.time);
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const readAllMessage = async (roomId) => {
  const roomRef = firestore.doc(`rooms/${roomId}`);
  const room = await roomRef.get();
  roomRef.update({
    messages: room.data().messages.map((message) => {
      if (message.user._id == roomId) {
        return { ...message, sent: true, received: true };
      } else {
        return message;
      }
    }),
    lastMessage: { ...room.data().lastMessage, sent: true, received: true },
  });
};

export const updateSingleProduct = async (product) => {
  const productRef = firestore.doc(`products/${product.id}`);
  console.log(product);
  try {
    await productRef.update({ ...product });
    const productSnapshot = await productRef.get();
    if (productSnapshot.exists) {
      try {
        await firestore
          .collection("productList")
          .doc(product.id)
          .set(
            stripProductForList({ id: product.id, ...productSnapshot.data() }),
            { merge: true },
          );
      } catch (e) {
        console.error("productList sync failed", e);
      }
    }
    return productSnapshot.data();
  } catch (error) {
    notifyError(error.message);
    console.log(error);
  }
};
export const updateAdminStatus = async (adminObj) => {
  const adminRef = firestore.doc(`admins/${adminObj.adminId}`);
  try {
    const snapShot = await adminRef.get();
    console.log(snapShot.data());
    await adminRef.update({
      status: adminObj.status,
      activeStatus: adminObj.activeStatus,
    });
    const updatedSnapShot = await adminRef.get();
    return { ...updatedSnapShot.data(), adminId: updatedSnapShot.id };
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const updateOrderApi = async (order) => {
  const orderRef = firestore.doc(`ordersApi/${order.orderId}`);
  const snapShot = await orderRef.get();
  if (snapShot.exists) {
    try {
      await orderRef.update({ ...order });
      const updatedOrder = await orderRef.get();
      return updatedOrder.data();
    } catch (error) {
      console.log("error creating orders", error.message);
      return;
    }
  } else {
    notifyError("No order was found to be updated");
  }
};

export const getCurrency = async () => {
  const currencyRef = firestore.doc("Currency/taka");
  try {
    const currency = await currencyRef.get();
    return currency.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const updateCurrency = async ({ taka, shippingFee }) => {
  const currencyRef = firestore.doc("Currency/taka");
  try {
    await currencyRef.set({ taka, shippingFee }, { merge: true });
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const makePayment = async (
  total,
  invoicesToPay,
  currentUser,
  admin,
  parcelsArray,
  paymentMethod,
) => {
  try {
    const res = await firestore.runTransaction(async (t) => {
      //first create a payment object
      const paymentObj = {
        paymentId: Math.floor(Math.random() * Date.now()),
        paidAt: new Date().toLocaleDateString("en-US").replaceAll("/", "-"),
        amount: total,
        paymentMethod,
        paidInvoice: [...invoicesToPay],
        approvedBy: admin.name,
      };

      // for transaction all reads should be done before all writes
      const paymentDayRef = firestore.doc(`paymentDays/${paymentObj.paidAt}`);
      const paymentDay = await t.get(paymentDayRef);
      const paymentHistoryRef = firestore.doc(
        `paymentHistory/${paymentObj.paymentId}`,
      );
      const paymentHistory = await t.get(paymentHistoryRef);
      // updatating the status invoiceStatus=Paid in parcelArray in admin
      parcelsArray.forEach(async (parcel) => {
        const orderRef = firestore.doc(`orders/${parcel.parcelId}`);
        await t.update(orderRef, {
          ...parcel,
          invoiceStatus: "Paid",
        });
      });

      // make all writes
      // make a payment in paymentdays
      console.log(paymentDay.data());
      const day = getDay();
      if (!paymentDay.exists) {
        t.set(paymentDayRef, {
          date: paymentObj.paidAt,
          total: total,
          day,
        });
      } else {
        t.update(paymentDayRef, {
          total: paymentDay.data().total + total,
        });
      }
      console.log(paymentDay.data());

      // make a payment in paymentHistory

      console.log(paymentHistory.data());
      if (!paymentHistory.exists) {
        t.set(paymentHistoryRef, {
          Email: currentUser
            ? currentUser.email && currentUser.email
            : admin.email,
          Name: currentUser
            ? currentUser.displayName && currentUser.displayName
            : admin.name,
          Id: currentUser ? currentUser.userId : "admin",
          uid: currentUser ? currentUser.uid : admin.adminId,
          Mobile: currentUser
            ? currentUser.mobileNo
              ? currentUser.mobileNo
              : ""
            : admin.mobileNo,
          ...paymentObj,
          day,
        });
      } else {
        notifyError("Your paymentId already exist. please try again later.");
      }
      console.log(paymentHistory.data());

      const newArray = parcelsArray.map((parcel) => {
        return { ...parcel, invoiceStatus: "Paid" };
      });

      console.log(parcelsArray[0]);
      console.log(newArray[0]);
      return newArray;
    });
    return res;
  } catch (e) {
    console.log("Transaction failure:", e);
    notifyError("Transaction failure");
    return [];
  }
};

const getDay = () => {
  const t = new Date();
  const dayInDigit = t.getDay();
  let day;
  if (dayInDigit == 0) {
    day = "Sunday";
  }
  if (dayInDigit == 1) {
    day = "Monday";
  }
  if (dayInDigit == 2) {
    day = "Tuesday";
  }
  if (dayInDigit == 3) {
    day = "Wednesday";
  }
  if (dayInDigit == 4) {
    day = "Thursday";
  }
  if (dayInDigit == 5) {
    day = "Friday";
  }
  if (dayInDigit == 6) {
    day = "Saturday";
  }
  return day;
};

export const getMultipleOrders = async (parcelIdArray) => {
  const ordersArray = [];
  for (let i = 0; i < parcelIdArray.length; i++) {
    const orderRef = firestore.doc(`orders/${parcelIdArray[i]}`);
    const snapShot = await orderRef.get();
    ordersArray.push(snapShot.data());
  }
  return ordersArray;
};

export const getAllBrands = async () => {
  const productsCollectionRef = firestore.collection("brands");

  try {
    const products = await productsCollectionRef.get();
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadBrand = async (productObj) => {
  const productRef = firestore.doc(`brands/${productObj.id}`);
  const snapShot = await productRef.get();
  const newProductObj = { ...productObj, file: "" };
  if (!snapShot.exists) {
    try {
      await productRef.set({
        ...newProductObj,
      });
      const updatedSnapShot = await productRef.get();
      return updatedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError("there is already a brand with similar id");
  }
};
export const uploadfreeShipping = async (value) => {
  const productRef = firestore.doc(`freeShipping/freeShipping`);
  const snapShot = await productRef.get();

  if (!snapShot.exists) {
    try {
      await productRef.set({
        value: value,
      });
      const updatedSnapShot = await productRef.get();
      return updatedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    try {
      await productRef.update({
        value: value,
      });
      const updatedSnapShot = await productRef.get();
      return updatedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  }
};

export const updateBrand = async (productObj) => {
  const productRef = firestore.doc(`brands/${productObj.id}`);
  const product = await productRef.get();
  try {
    delete productObj.file;
    await productRef.update({ ...productObj });
    const updatedSnapShot = await productRef.get();
    return updatedSnapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteBrand = async (id, parentId) => {
  const productRef = firestore.doc(`brands/${id}`);
  const childBrandsRef = firestore
    .collection(`brands`)
    .where("parentBrand", "==", id);
  const childBrands = await childBrandsRef.get();
  try {
    childBrands.forEach(async (doc) => {
      const productRef = firestore.doc(`brands/${doc.data().id}`);
      await productRef.update({
        parentBrand: parentId,
      });
    });
    await productRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getAllCoupons = async () => {
  const productsCollectionRef = firestore.collection("coupons");

  try {
    const products = await productsCollectionRef.get();
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadCoupon = async (productObj) => {
  const productRef = firestore.doc(`coupons/${productObj.id}`);
  const snapShot = await productRef.get();
  const newProductObj = { ...productObj, file: "" };
  if (!snapShot.exists) {
    try {
      await productRef.set({
        ...newProductObj,
      });
      const updatedSnapShot = await productRef.get();
      return updatedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError("there is already a coupon with similar id");
  }
};

export const updateCoupon = async (productObj) => {
  const productRef = firestore.doc(`coupons/${productObj.id}`);
  const product = await productRef.get();
  try {
    delete productObj.file;
    await productRef.update({ ...productObj });
    const updatedSnapShot = await productRef.get();
    return updatedSnapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteCoupon = async (id) => {
  const productRef = firestore.doc(`coupons/${id}`);
  try {
    await productRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllCategories = async () => {
  const productsCollectionRef = firestore.collection("categories");

  try {
    const products = await productsCollectionRef.get();
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getAllHomeScreenCategories = async () => {
  const productsCollectionRef = firestore
    .collection("categories")
    .where("homePage", "==", true);

  try {
    const products = await productsCollectionRef.get();
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadCategory = async (productObj, homeCategoriesLength) => {
  const productRef = firestore.doc(`categories/${productObj.id}`);
  const snapShot = await productRef.get();
  const newProductObj = { ...productObj, file: "" };
  if (!snapShot.exists) {
    try {
      await productRef.set({
        ...newProductObj,
      });
      const singlCategoryProductsCollectionRef = firestore
        .collection("products")
        .where("checkedValues", "array-contains", productObj.id)
        .orderBy("id", "desc")
        .limit(10);
      const products = await singlCategoryProductsCollectionRef.get();
      console.log(products);
      if (productObj.homePage && productObj.homePosition) {
        // jodi homepage er hoy shekhetre dekhbo etar product gula already available ache kina. na thakle add korbo r thakle bad dibo
        products.forEach(async (doc) => {
          const productRef = firestore.doc(`homeProducts/${doc.data().id}`);
          const product = await productRef.get();
          if (product.exists) {
            // jodi product agei thake in that case product r add korbo na
          } else {
            // product jodi homeproducts te na thake tokhon add korbo
            productRef.set({
              ...doc.data(),
              categoryId: productObj.id,
            });
          }
        });
        const productsCollectionRef = firestore
          .collection("categories")
          .where("homePage", "==", true);
        const products = await productsCollectionRef.get();

        products.forEach(async (doc) => {
          const productRef2 = firestore.doc(`categories/${doc.data().id}`);
          const product2 = await productRef2.get();
          if (
            product2.data().homePosition >= productObj.homePosition &&
            product2.data().id != productObj.id
          ) {
            await productRef2.update({
              homePosition: Number(product2.data().homePosition) + 1,
            });
          }
        });
      } else {
        // jodi product homscreen te na hoy tokhon jodi homeproducts te product thake remove kore dibo
        products.forEach(async (doc) => {
          const productRef = firestore.doc(`homeProducts/${doc.data().id}`);
          const product = await productRef.get();
          if (product.exists) {
            // jodi product agei thake in that case product delete kore dibo. jehetu eta r homescreen te nai
            await productRef.delete();
          } else {
            // product jodi homeproducts te na thake tokhon kichu korar dorkar nai
          }
        });
      }
      const updatedSnapShot = await productRef.get();

      return updatedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError("there is already a category with similar id");
  }
};

export const updateCategory = async (productObj, homeCategoriesLength) => {
  const productRef = firestore.doc(`categories/${productObj.id}`);
  const product = await productRef.get();
  try {
    delete productObj.file;
    await productRef.update({ ...productObj });
    const singlCategoryProductsCollectionRef = firestore
      .collection("products")
      .where("checkedValues", "array-contains", productObj.id)
      .orderBy("id", "desc")
      .limit(10);
    const products = await singlCategoryProductsCollectionRef.get();
    console.log(products);
    if (productObj.homePage && productObj.homePosition) {
      // jodi homepage er hoy shekhetre dekhbo etar product gula already available ache kina. na thakle add korbo r thakle bad dibo
      products.forEach(async (doc) => {
        const productRef = firestore.doc(`homeProducts/${doc.data().id}`);
        const product = await productRef.get();
        if (product.exists) {
          // jodi product agei thake in that case product r add korbo na
        } else {
          // product jodi homeproducts te na thake tokhon add korbo
          productRef.set({
            ...doc.data(),
            categoryId: productObj.id,
          });
        }
      });
      const productsCollectionRef = firestore
        .collection("categories")
        .where("homePage", "==", true);
      const products2 = await productsCollectionRef.get();
      products2.forEach(async (doc) => {
        const productRef2 = firestore.doc(`categories/${doc.data().id}`);
        const product2 = await productRef2.get();
        console.log(doc.data());
        // ekane proti ta category er product nibo 10 ta kore and save korbo homeProducts collection te

        if (product.data().homePosition) {
          // homePostion age thakle shekhetre only swap hobe oi duitar moddhe or
          if (
            product2.data().homePosition == productObj.homePosition &&
            product2.data().id != productObj.id
          ) {
            await productRef2.update({
              homePosition: product.data().homePosition,
            });
          }
        } else {
          if (
            product2.data().homePosition != productObj.homePosition &&
            product2.data().id != productObj.id
          ) {
            await productRef2.update({
              homePosition: Number(product2.data().homePosition) + 1,
            });
          }
        }
      });
    } else {
      // jodi product homscreen te na hoy tokhon jodi homeproducts te product thake remove kore dibo
      const singlCategoryProductsCollectionRef2 = firestore
        .collection("homeProducts")
        .where("checkedValues", "array-contains", productObj.id);

      const products3 = await singlCategoryProductsCollectionRef2.get();
      products3.forEach(async (doc) => {
        const productRef = firestore.doc(`homeProducts/${doc.data().id}`);

        // jodi product agei thake in that case product delete kore dibo. jehetu eta r homescreen te nai
        await productRef.delete();
      });
    }
    const updatedSnapShot = await productRef.get();
    return updatedSnapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteCategory = async (productObj, parentId) => {
  const productRef = firestore.doc(`categories/${productObj.id}`);
  const childCategoriesRef = firestore
    .collection(`categories`)
    .where("parentCategory", "==", productObj.id);
  const childCategories = await childCategoriesRef.get();
  try {
    childCategories.forEach(async (doc) => {
      const productRef = firestore.doc(`categories/${doc.data().id}`);
      await productRef.update({
        parentCategory: parentId,
      });
    });
    await productRef.delete();
    if (productObj.homePosition) {
      const productsCollectionRef = firestore
        .collection("categories")
        .where("homePage", "==", true);
      const products = await productsCollectionRef.get();

      products.forEach(async (doc) => {
        const productRef2 = firestore.doc(`categories/${doc.data().id}`);
        const product2 = await productRef2.get();
        if (
          product2.data().homePosition >= productObj.homePosition &&
          product2.data().id != productObj.id
        ) {
          await productRef2.update({
            homePosition: Number(product2.data().homePosition) - 1,
          });
        }
      });
    }
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getAllBanners = async () => {
  const productsCollectionRef = firestore.collection("banners");

  try {
    const products = await productsCollectionRef.get();
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadBanner = async (productObj) => {
  const productRef = firestore.doc(`banners/${productObj.id}`);
  const snapShot = await productRef.get();
  const newProductObj = { ...productObj, file: "" };
  if (productObj.secondBanner) {
    const collectionRef = firestore
      .collection(`banners`)
      .where("secondBanner", "==", true);
    const collection = await collectionRef.get();
    collection.forEach(async (doc) => {
      const bannerRef = firestore.doc(`banners/${doc.data().id}`);
      await bannerRef.update({
        secondBanner: false,
      });
    });
  }
  if (!snapShot.exists) {
    try {
      await productRef.set({
        ...newProductObj,
      });
      const updatedSnapShot = await productRef.get();
      return updatedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError("there is already a category with similar id");
  }
};

export const updateBanner = async (productObj) => {
  const productRef = firestore.doc(`banners/${productObj.id}`);
  const product = await productRef.get();
  if (productObj.secondBanner) {
    const collectionRef = firestore
      .collection(`banners`)
      .where("secondBanner", "==", true);
    const collection = await collectionRef.get();
    collection.forEach(async (doc) => {
      const bannerRef = firestore.doc(`banners/${doc.data().id}`);
      await bannerRef.update({
        secondBanner: false,
      });
    });
  }
  try {
    delete productObj.file;
    await productRef.update({ ...productObj });
    const updatedSnapShot = await productRef.get();
    return updatedSnapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteBanner = async (id) => {
  const productRef = firestore.doc(`banners/${id}`);
  try {
    await productRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllTags = async () => {
  const productsCollectionRef = firestore.collection("tags");

  try {
    const products = await productsCollectionRef.get();
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadTag = async (productObj) => {
  const productRef = firestore.doc(`tags/${productObj.id}`);
  const snapShot = await productRef.get();
  const newProductObj = { ...productObj, file: "" };
  if (!snapShot.exists) {
    try {
      await productRef.set({
        ...newProductObj,
      });
      const updatedSnapShot = await productRef.get();
      return updatedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError("there is already a tag with similar id");
  }
};

export const updateTag = async (productObj) => {
  const productRef = firestore.doc(`tags/${productObj.id}`);

  try {
    delete productObj.file;
    await productRef.update({ ...productObj });
    const updatedSnapShot = await productRef.get();
    return updatedSnapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteTag = async (id) => {
  const productRef = firestore.doc(`tags/${id}`);
  try {
    await productRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getAllAttributes = async () => {
  const productsCollectionRef = firestore.collection("attributes");
  try {
    const products = await productsCollectionRef.get();
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadAttribute = async (productObj) => {
  const productRef = firestore.doc(`attributes/${productObj.id}`);
  const snapShot = await productRef.get();
  const newProductObj = { ...productObj, file: "" };
  if (!snapShot.exists) {
    try {
      await productRef.set({
        ...newProductObj,
        enableVisibility: true,
        enableVariations: true,
      });
      const updatedSnapShot = await productRef.get();
      return updatedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError("there is already a attribute with similar id");
  }
};

export const updateAttribute = async (productObj) => {
  const productRef = firestore.doc(`attributes/${productObj.id}`);
  try {
    delete productObj.file;
    await productRef.update({ ...productObj });
    const updatedSnapShot = await productRef.get();
    return updatedSnapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteAttribute = async (id) => {
  const attrRef = firestore.doc(`attributes/${id}`);
  const termsRef = firestore
    .collection(`attributeTerms`)
    .where("parentId", "==", id);
  const terms = await termsRef.get();
  try {
    await attrRef.delete();
    terms.forEach(async (doc) => {
      const termRef = firestore.doc(`attributes/${doc.data().id}`);
      await termRef.delete();
    });
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllAttributeTerms = async (id) => {
  const productsCollectionRef = firestore
    .collection("attributeTerms")
    .where("parentId", "==", id);
  try {
    const products = await productsCollectionRef.get();
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    // attribute term chole gele nicher 2 line comment out korte hobe tahole thik hoye jabe
    // const attrRef = firestore.doc(`attributes/${id}`);
    // await attrRef.update({
    //   terms: productsArray,
    // });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadAttributeTerm = async (productObj) => {
  const termRef = firestore.doc(`attributeTerms/${productObj.id}`);
  const attrRef = firestore.doc(`attributes/${productObj.parentId}`);
  const snapShot = await termRef.get();
  const attr = await attrRef.get();
  const newProductObj = { ...productObj, file: "" };
  if (!snapShot.exists) {
    try {
      await termRef.set({
        ...newProductObj,
      });
      await attrRef.update({
        terms: [...attr.data().terms, newProductObj],
      });
      const updatedSnapShot = await termRef.get();
      return updatedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError("there is already a terms with similar id");
  }
};

export const fetchAllProducts = async (chunks) => {
  // Try matching by Firestore document ID (the primary key Algolia uses for objectID)
  const byDocId = (
    await Promise.all(
      chunks.map((chunk) =>
        firestore
          .collection("products")
          .where(firebase.firestore.FieldPath.documentId(), "in", chunk)
          .get()
          .then((qs) => qs.docs.map((doc) => ({ id: doc.id, ...doc.data() })))
          .catch(() => []),
      ),
    )
  ).flat();

  if (byDocId.length > 0) return byDocId;

  // Fallback: some products store a custom id field that Algolia indexed instead
  const byIdField = (
    await Promise.all(
      chunks.map((chunk) =>
        firestore
          .collection("products")
          .where("id", "in", chunk)
          .get()
          .then((qs) => qs.docs.map((doc) => ({ id: doc.id, ...doc.data() })))
          .catch(() => []),
      ),
    )
  ).flat();

  return byIdField;
};

export const updateAttributeTerm = async (productObj) => {
  const termRef = firestore.doc(`attributeTerms/${productObj.id}`);
  const attrRef = firestore.doc(`attributes/${productObj.parentId}`);
  const attr = await attrRef.get();
  const newTerms = attr.data().terms.map((term) => {
    if (term.id == productObj.id) {
      return productObj;
    } else {
      return term;
    }
  });
  try {
    delete productObj.file;
    await termRef.update({ ...productObj });
    await attrRef.update({
      terms: newTerms,
    });
    const updatedSnapShot = await termRef.get();
    return updatedSnapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteAttributeTerm = async (id, parentId) => {
  const termRef = firestore.doc(`attributeTerms/${id}`);
  const attrRef = firestore.doc(`attributes/${parentId}`);
  const attr = await attrRef.get();
  const newTerms = attr.data().terms.filter((term) => term.id !== id);
  try {
    await termRef.delete();
    await attrRef.update({
      terms: newTerms,
    });
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllCampaigns = async () => {
  const productsCollectionRef = firestore.collection("campaigns");

  try {
    const products = await productsCollectionRef.get();
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadCampaign = async (productObj) => {
  const productRef = firestore.doc(`campaigns/${productObj.id}`);
  const snapShot = await productRef.get();
  const newProductObj = { ...productObj, file: "" };
  if (productObj.secondBanner) {
    const collectionRef = firestore
      .collection(`campaigns`)
      .where("secondBanner", "==", true);
    const collection = await collectionRef.get();
    collection.forEach(async (doc) => {
      const bannerRef = firestore.doc(`campaigns/${doc.data().id}`);
      await bannerRef.update({
        secondBanner: false,
      });
    });
  }
  if (!snapShot.exists) {
    try {
      await productRef.set({
        ...newProductObj,
      });
      const updatedSnapShot = await productRef.get();
      return updatedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError("there is already a category with similar id");
  }
};

export const updateCampaign = async (productObj) => {
  const productRef = firestore.doc(`campaigns/${productObj.id}`);
  const product = await productRef.get();
  if (productObj.secondBanner) {
    const collectionRef = firestore
      .collection(`campaigns`)
      .where("secondBanner", "==", true);
    const collection = await collectionRef.get();
    collection.forEach(async (doc) => {
      const bannerRef = firestore.doc(`campaigns/${doc.data().id}`);
      await bannerRef.update({
        secondBanner: false,
      });
    });
  }
  try {
    delete productObj.file;
    await productRef.update({ ...productObj });
    const updatedSnapShot = await productRef.get();
    return updatedSnapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteCampaign = async (id) => {
  const productRef = firestore.doc(`campaigns/${id}`);
  try {
    await productRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getAllAnnouncements = async () => {
  const productsCollectionRef = firestore.collection("announcements");

  try {
    const products = await productsCollectionRef.get();
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadAnnouncement = async (productObj) => {
  const productRef = firestore.doc(`announcements/${productObj.id}`);
  const snapShot = await productRef.get();
  const newProductObj = { ...productObj, file: "" };
  if (productObj.secondBanner) {
    const collectionRef = firestore
      .collection(`announcements`)
      .where("secondBanner", "==", true);
    const collection = await collectionRef.get();
    collection.forEach(async (doc) => {
      const bannerRef = firestore.doc(`announcements/${doc.data().id}`);
      await bannerRef.update({
        secondBanner: false,
      });
    });
  }
  if (!snapShot.exists) {
    try {
      await productRef.set({
        ...newProductObj,
      });
      const updatedSnapShot = await productRef.get();
      return updatedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError("there is already a category with similar id");
  }
};

export const updateAnnouncement = async (productObj) => {
  const productRef = firestore.doc(`announcements/${productObj.id}`);
  const product = await productRef.get();
  if (productObj.visible) {
    const productsCollectionRef = firestore.collection("announcements");
    const products = await productsCollectionRef.get();
    products.forEach(async (doc) => {
      const annoucementRef = firestore.doc(`announcements/${doc.data().id}`);
      await annoucementRef.update({
        ...doc.data(),
        visible: false,
      });
    });
  }
  try {
    delete productObj.file;
    await productRef.update({ ...productObj });
    const updatedSnapShot = await productRef.get();
    return updatedSnapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteAnnouncement = async (id) => {
  const productRef = firestore.doc(`announcements/${id}`);
  try {
    await productRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getSingleMonthlyExpense = async (month) => {
  const expensesCollectionRef = firestore
    .collection("dailyExpenses")
    .where("month", "==", month);
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getProcessedSteadfastPaymentIds = async () => {
  const expensesCollectionRef = firestore
    .collection("dailyExpenses")
    .where("category", "==", "Delivery charge");
  try {
    const expenses = await expensesCollectionRef.get();
    const ids = new Set();
    expenses.forEach((doc) => {
      const data = doc.data();
      if (data.subCategory) ids.add(String(data.subCategory));
    });
    return ids;
  } catch (error) {
    notifyError(error.message || String(error));
    return new Set();
  }
};

// Caches the last known Steadfast /payments page number so the payments list
// page doesn't need to re-search a wide fixed range every load — Steadfast's
// page count only grows over time, so this is used as a starting point to
// cheaply detect how far it's grown since last time.
const STEADFAST_META_DOC = () => firestore.doc("meta/steadfastPayments");

export const getSteadfastLastPage = async () => {
  try {
    const snap = await STEADFAST_META_DOC().get();
    const data = snap.data();
    return (data && data.lastPage) || 0;
  } catch (error) {
    notifyError(error.message || String(error));
    return 0;
  }
};

export const updateSteadfastLastPage = async (lastPage) => {
  try {
    await STEADFAST_META_DOC().set({ lastPage }, { merge: true });
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllMonthlyExpense = async () => {
  const expensesCollectionRef = firestore.collection("monthlyExpense");
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllPendingExpensesByDay = async (day) => {
  const expensesCollectionRef = firestore
    .collection("dailyExpenses")
    .where("date", "==", day)
    .where("status", "==", "pending");
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

// Categories whose monthly summary is read back without filtering by
// subCategory (see getAllMonthly()'s query branching) — must be keyed by
// month+category only wherever a categoryMonthlyExpense doc id is built,
// here included. subCategory for these is a free-typed, per-transaction
// note (lot number, product name, promo description), so including it in
// the doc id would create a new "duplicate" month row every time someone
// typed a different note, instead of merging into one.
const SUBCATEGORY_AGNOSTIC_CATEGORIES = [
  "BUY PRODUCTS", "Boosting", "SHIPPING", "ORDERS", "TRANSPORT", "COURIER", "INVEST",
];

// Firestore hard-caps a WriteBatch at 500 operations. Rather than attempt a
// chunked multi-batch commit for an oversized approval (which would give up
// the "all approved or all failed" guarantee across chunk boundaries), we
// simply refuse to run and ask the admin to approve in smaller groups —
// realistic daily volume is tens of items, so this should never trigger in
// practice, and a clean upfront rejection is far easier to reason about
// (and safe) than partial-atomicity chunking logic that can't be exercised
// against a live Firestore in this environment.
const APPROVAL_BATCH_OP_LIMIT = 450;

// Walks backward from `date` (up to 365 days) to find the most recent prior
// cashSummary doc, used only to seed previousCash/remainingBalance if
// today's own cashSummary/{date} doc doesn't exist yet.
async function findLastCashSummarySnap(day, month, year) {
  for (let i = 1; i < 365; i++) {
    const dateObj = new Date(year, parseInt(month) - 1, day - i);
    const previousDate = new Date(dateObj.getTime() - 86400000);
    const previousDayRef = firestore.doc(
      `cashSummary/${previousDate.toLocaleDateString("en-GB").replaceAll("/", "-")}`,
    );
    const previousDaySnap = await previousDayRef.get();
    if (previousDaySnap.exists) return previousDaySnap;
  }
  return null;
}

// Reads everything the cash-summary side of an approval batch needs, ahead
// of any writes: today's own cashSummary/{date} doc, the most recent prior
// day (as a previousCash seed if today's doc doesn't exist yet), and every
// day between `date` and today that already has a doc (so the balance
// change can be propagated forward through the days already on record).
async function readCashSummaryContext(date) {
  const [day, month, year] = date.split("/");
  const approvalDate = new Date(year, parseInt(month) - 1, day);
  const today = new Date();
  const diffDays = Math.ceil(Math.abs(today - approvalDate) / (1000 * 60 * 60 * 24));

  const cashSummaryRef = firestore.doc(`cashSummary/${date.replaceAll("/", "-")}`);
  const [cashSummarySnap, lastDaySnap] = await Promise.all([
    cashSummaryRef.get(),
    findLastCashSummarySnap(day, month, year),
  ]);

  const forwardDayRefs = [];
  if (diffDays > 0) {
    for (let i = 1; i <= diffDays; i++) {
      const dateObj = new Date(year, parseInt(month) - 1, parseInt(day) + i);
      forwardDayRefs.push(
        firestore.doc(`cashSummary/${dateObj.toLocaleDateString("en-GB").replaceAll("/", "-")}`),
      );
    }
  }
  const forwardDaySnaps = await Promise.all(forwardDayRefs.map((ref) => ref.get()));

  return { cashSummaryRef, cashSummarySnap, lastDaySnap, forwardDayRefs, forwardDaySnaps };
}

// Queues the cashSummary writes (today's doc + forward propagation) onto an
// already-open batch. `sign` is +1 for cash-in (adds to totals/balance) or
// -1 for cash-out (subtracts) — mirrors updateCashSummaryCashIn/Out's math.
function queueCashSummaryWrites(batch, ctx, { month, date, total, sign, totalsField }) {
  const { cashSummaryRef, cashSummarySnap, lastDaySnap, forwardDayRefs, forwardDaySnaps } = ctx;

  if (cashSummarySnap.exists) {
    const data = cashSummarySnap.data();
    batch.update(cashSummaryRef, {
      [totalsField]: (parseInt(data[totalsField]) || 0) + total,
      remainingBalance: (parseInt(data.remainingBalance) || 0) + sign * total,
    });
  } else {
    const lastDayRemaining = lastDaySnap ? parseInt(lastDaySnap.data().remainingBalance) || 0 : 0;
    batch.set(cashSummaryRef, {
      month,
      date,
      previousCash: lastDayRemaining,
      totalCashIns: totalsField === "totalCashIns" ? total : 0,
      totalCashOuts: totalsField === "totalCashOuts" ? total : 0,
      remainingBalance: lastDayRemaining + sign * total,
    });
  }

  forwardDayRefs.forEach((ref, i) => {
    const snap = forwardDaySnaps[i];
    if (snap.exists) {
      const data = snap.data();
      batch.update(ref, {
        previousCash: (parseInt(data.previousCash) || 0) + sign * total,
        remainingBalance: (parseInt(data.remainingBalance) || 0) + sign * total,
      });
    }
  });
}

// Approves every pending item in `expenses` (all dailyExpenses docs for one
// day) as a single atomic operation, together with the day's cash summary —
// either everything commits, or (on any failure) nothing does.
//
// Replaces the old per-item approveExpense(expense): that version built and
// committed its own independent firestore.batch() per item, so a failure
// partway through a day's worth of approvals left a mixed approved/pending
// state, and multiple same-day expenses landing on the same aggregate doc
// (e.g. three SHIPPING expenses all resolving to
// categoryMonthlyExpense/{month}-SHIPPING) would silently lose all but the
// last one's contribution if naively queued as separate batch.update()
// calls against the same doc — WriteBatch keeps only the last queued write
// per document path, it doesn't accumulate. This version groups by target
// document and sums deltas before queuing any write, so that can't happen.
export const approveExpensesBatch = async (expenses, { month, date, total }) => {
  if (!expenses || expenses.length === 0) {
    return { success: true, approvedIds: [] };
  }

  try {
    // Phase A — read every expense doc fresh (don't trust component state),
    // and bail out before queuing anything if any item isn't actually
    // pending anymore (e.g. approved from a second tab).
    const expenseRefs = expenses.map((e) => firestore.doc(`dailyExpenses/${e.id}`));
    const expenseSnaps = await Promise.all(expenseRefs.map((ref) => ref.get()));

    for (let i = 0; i < expenseSnaps.length; i++) {
      if (!expenseSnaps[i].exists || expenseSnaps[i].data().status !== "pending") {
        return {
          success: false,
          reason: "stale-item",
          message: `"${expenses[i].subCategory || expenses[i].note || expenses[i].id}" is no longer pending — nothing was approved.`,
          approvedIds: [],
        };
      }
    }
    const resolved = expenseSnaps.map((snap) => ({ id: snap.id, ...snap.data() }));

    // Phase B — group by target document, summing deltas so multiple items
    // hitting the same aggregate doc combine instead of clobbering.
    const targets = new Map();
    const addTarget = (ref, amount, kind, meta) => {
      const key = ref.path;
      if (!targets.has(key)) targets.set(key, { ref, deltaAmount: 0, kind, meta });
      const entry = targets.get(key);
      entry.deltaAmount += amount;
      entry.meta = meta; // last-contributing-expense wins, same as sequential commits did in practice
    };

    resolved.forEach((expense) => {
      const amount = parseInt(expense.amount) || 0;

      const categoryMonthlyExpenseId = SUBCATEGORY_AGNOSTIC_CATEGORIES.includes(expense.category)
        ? `${expense.month}-${expense.category}`
        : `${expense.month}-${expense.category}-${String(expense.subCategory).replaceAll("/", "_")}`;
      addTarget(
        firestore.doc(`categoryMonthlyExpense/${categoryMonthlyExpenseId}`),
        amount,
        expense.category === "SALARY" ? "categoryMonthlyExpenseSalary" : "categoryMonthlyExpense",
        {
          id: categoryMonthlyExpenseId,
          category: expense.category,
          subCategory: expense.subCategory,
          month: expense.month,
        },
      );

      if (expense.category === "SALARY") {
        addTarget(firestore.doc(`monthlySalary/${expense.month}`), amount, "monthlySalary", {
          month: expense.month,
        });
      } else if (expense.category === "LOAN" || expense.category === "MONTHLY INSTALLMENT") {
        const customerCollection =
          expense.category === "LOAN" ? "customerLoans" : "customerInstallments";
        addTarget(
          firestore.doc(`${customerCollection}/${expense.uid}`),
          amount,
          "customer",
          { customer: expense.subCategory, uid: expense.uid },
        );
      }

      addTarget(firestore.doc(`monthlyExpense/${expense.month}`), amount, "monthlyExpense", {
        id: expense.month,
      });
    });

    // Phase C — read each unique target doc exactly once.
    const targetEntries = Array.from(targets.values());
    const targetSnaps = await Promise.all(targetEntries.map((t) => t.ref.get()));

    // Cash-summary reads (backward seed lookup + today's doc + forward
    // propagation chain) — also all reads, no writes yet.
    const cashSummaryCtx = await readCashSummaryContext(date);

    const estimatedOps =
      resolved.length + targetEntries.length + 1 + cashSummaryCtx.forwardDayRefs.length;
    if (estimatedOps > APPROVAL_BATCH_OP_LIMIT) {
      return {
        success: false,
        reason: "too-many-items",
        message: `Too many pending items to approve atomically at once (${estimatedOps} operations). Please approve in smaller groups.`,
        approvedIds: [],
      };
    }

    // Phase D — queue writes.
    const batch = firestore.batch();

    resolved.forEach((expense) => {
      batch.update(firestore.doc(`dailyExpenses/${expense.id}`), { status: "approved" });
    });

    targetEntries.forEach((entry, i) => {
      const snap = targetSnaps[i];
      const existingAmount = snap.exists ? parseInt(snap.data().amount) || 0 : 0;
      const newAmount = existingAmount + entry.deltaAmount;

      if (entry.kind === "categoryMonthlyExpense" || entry.kind === "categoryMonthlyExpenseSalary") {
        if (snap.exists) {
          const update = { amount: newAmount };
          if (entry.kind === "categoryMonthlyExpenseSalary") {
            update.paid = parseInt(snap.data().salary) === newAmount;
          }
          batch.update(entry.ref, update);
        } else {
          batch.set(entry.ref, {
            id: entry.meta.id,
            amount: newAmount,
            category: entry.meta.category,
            subCategory: entry.meta.subCategory,
            month: entry.meta.month,
            paid: false,
            salary: 0,
          });
        }
      } else if (entry.kind === "monthlySalary") {
        if (snap.exists) {
          batch.update(entry.ref, { amount: newAmount });
        } else {
          batch.set(entry.ref, { month: entry.meta.month, amount: newAmount });
        }
      } else if (entry.kind === "customer") {
        if (snap.exists) {
          batch.update(entry.ref, { amount: newAmount, customer: entry.meta.customer });
        } else {
          batch.set(entry.ref, {
            customer: entry.meta.customer,
            amount: newAmount,
            uid: entry.meta.uid,
          });
        }
      } else if (entry.kind === "monthlyExpense") {
        if (snap.exists) {
          batch.update(entry.ref, { amount: newAmount });
        } else {
          batch.set(entry.ref, { id: entry.meta.id, amount: newAmount });
        }
      }
    });

    // Phase E — fold in the cash-summary update (cash-out subtracts from
    // remainingBalance, matching updateCashSummaryCashOut's convention).
    queueCashSummaryWrites(batch, cashSummaryCtx, {
      month,
      date,
      total,
      sign: -1,
      totalsField: "totalCashOuts",
    });

    // Phase F — commit. Everything above was reads/in-memory aggregation
    // only, so a failure here leaves Firestore completely untouched.
    await batch.commit();
    return { success: true, approvedIds: resolved.map((e) => e.id) };
  } catch (error) {
    console.error("Error approving expenses:", error);
    return {
      success: false,
      reason: "batch-commit-failure",
      message: error.message || "Failed to approve expenses — nothing was changed.",
      approvedIds: [],
    };
  }
};

export const getAllPendingExpenses = async () => {
  const expensesCollectionRef = firestore
    .collection("dailyExpenses")
    .where("status", "==", "pending");
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteExpense = async (expenseId) => {
  const expenseRef = firestore.doc(`dailyExpenses/${expenseId}`);
  const snapShot = await expenseRef.get();
  console.log(snapShot.data());
  try {
    await expenseRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const updateExpense = async (expenseObj) => {
  const expenseRef = firestore.doc(`dailyExpenses/${expenseObj.id}`);
  try {
    await expenseRef.update({ ...expenseObj });
    const snapShot = await expenseRef.get();
    return snapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadExpense = async (expenseObj) => {
  const expenseRef = firestore.doc(`dailyExpenses/${expenseObj.id}`);
  const snapShot = await expenseRef.get();
  if (!snapShot.exists) {
    try {
      await expenseRef.set({
        ...expenseObj,
      });
      console.log(snapShot.data());
      const uploadedSnapShot = await expenseRef.get();
      return uploadedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError("there is already a expense with similar id,try again later");
  }
};

export const getAllExpenses = async (day) => {
  const expensesCollectionRef = firestore
    .collection("dailyExpenses")
    .where("date", "==", day);
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllOffices = async () => {
  const officesCollectionRef = firestore.collection("offices");
  try {
    const offices = await officesCollectionRef.get();
    const officesArray = [];
    offices.forEach((doc) => {
      officesArray.push(doc.data());
    });
    return officesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadOffice = async (officeObj) => {
  const officeRef = firestore.doc(`offices/${officeObj.officeId}`);
  const snapShot = await officeRef.get();
  if (!snapShot.exists) {
    try {
      await officeRef.set({
        ...officeObj,
      });
      console.log(snapShot.data());
      const uploadedSnapShot = await officeRef.get();
      return uploadedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError(
      "there is already a office with similar name, please change the country name and try again",
    );
  }
};

export const updateOffice = async (officeObj) => {
  const officeRef = firestore.doc(`offices/${officeObj.officeId}`);
  try {
    await officeRef.update({ ...officeObj });
    const snapShot = await officeRef.get();
    return snapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteOffice = async (officeId) => {
  const officeRef = firestore.doc(`offices/${officeId}`);
  const snapShot = await officeRef.get();
  console.log(snapShot.data());
  try {
    await officeRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getSingleCashSummary = async () => {
  const date = new Date();
  const cashSummaryRef = firestore.doc(
    `cashSummary/${date.toLocaleDateString("en-GB").replaceAll("/", "-")}`,
  );
  const cashSummary = await cashSummaryRef.get();
  if (cashSummary.exists) {
    return cashSummary.data();
  } else {
    let lastDay;
    for (let i = 0; i < 365; i++) {
      let [day, month, year] = date.toLocaleDateString("en-GB").split("/");
      let dateObj = new Date(year, parseInt(month - 1), day - i);
      let previousDate = new Date(dateObj.getTime().toString() - 86400000);
      const previousDayRef = firestore.doc(
        `cashSummary/${previousDate
          .toLocaleDateString("en-GB")
          .replaceAll("/", "-")}`,
      );
      const previouseDay = await previousDayRef.get();
      if (previouseDay.exists) {
        lastDay = previouseDay.data();
        break;
      }
    }
    console.log(lastDay);
    await cashSummaryRef.set({
      month: getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      previousCash:
        lastDay && lastDay.remainingBalance
          ? parseInt(lastDay.remainingBalance)
          : 0,
      totalCashIns: 0,
      totalCashOuts: 0,
      remainingBalance:
        lastDay && lastDay.remainingBalance
          ? parseInt(lastDay.remainingBalance)
          : 0,
    });
    const updatedSnapShot = await cashSummaryRef.get();
    return updatedSnapShot.data();
  }
};

export const uploadCashIn = async (cashInObj) => {
  const cashInRef = firestore.doc(`dailyCashIn/${cashInObj.id}`);
  const snapShot = await cashInRef.get();
  if (!snapShot.exists) {
    try {
      await cashInRef.set({
        ...cashInObj,
      });
      console.log(snapShot.data());
      const uploadedSnapShot = await cashInRef.get();
      return uploadedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError("there is already a cash in with similar id,try again later");
  }
};

export const updateCashIn = async (cashInObj) => {
  const cashInRef = firestore.doc(`dailyCashIn/${cashInObj.id}`);
  try {
    await cashInRef.update({ ...cashInObj });
    const snapShot = await cashInRef.get();
    return snapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllDocumentExpressRates = async () => {
  const expressRatesDocumentsCollectionRef = firestore.collection(
    "expressRatesDocuments",
  );
  try {
    const expressRatesDocuments =
      await expressRatesDocumentsCollectionRef.get();
    const expressRatesDocumentsArray = [];
    expressRatesDocuments.forEach((doc) => {
      expressRatesDocumentsArray.push(doc.data());
    });
    return expressRatesDocumentsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllEmployees = async () => {
  const employeesCollectionRef = firestore.collection("employees");
  try {
    const employees = await employeesCollectionRef.get();
    const employeesArray = [];
    employees.forEach((doc) => {
      employeesArray.push(doc.data());
    });
    return employeesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllMonthlyCashSummary = async () => {
  const expensesCollectionRef = firestore.collection("cashSummary");
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllMonthlyCashIn = async () => {
  const expensesCollectionRef = firestore.collection("monthlyCashIn");
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllMonthlySalary = async () => {
  const expensesCollectionRef = firestore.collection(`monthlySalary`);

  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getSingleCategoryProducts = async (categories, startAfter) => {
  let productsCollectionRef;
  console.log(startAfter);
  if (startAfter) {
    productsCollectionRef = firestore
      .collection("products")
      .where("checkedValues", "array-contains-any", categories)
      .orderBy("name")
      .startAfter(startAfter);
  } else {
    productsCollectionRef = firestore
      .collection("products")
      .where("checkedValues", "array-contains-any", categories)
      .orderBy("name");
  }
  const products = await productsCollectionRef.get();
  const lastProduct = products.docs[products.docs.length - 1];

  try {
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return { productsArray, lastProduct };
  } catch (error) {
    notifyError(error.message || String(error));
    console.log(error);
  }
};

export const getSingleBrandProducts = async (brandId, startAfter) => {
  let productsCollectionRef;
  console.log(startAfter);
  if (startAfter) {
    productsCollectionRef = firestore
      .collection("products")
      .where("checkedValues2", "array-contains", brandId)
      .orderBy("id", "desc")
      .startAfter(startAfter);
  } else {
    productsCollectionRef = firestore
      .collection("products")
      .where("checkedValues2", "array-contains", brandId)
      .orderBy("id", "desc");
  }
  const products = await productsCollectionRef.get();
  const lastProduct = products.docs[products.docs.length - 1];
  try {
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return { productsArray, lastProduct };
  } catch (error) {
    notifyError(error.message || String(error));
    console.log(error);
  }
};
export const getSingleCampaignProducts = async (campaignId, startAfter) => {
  let productsCollectionRef;
  console.log(startAfter);
  if (startAfter) {
    productsCollectionRef = firestore
      .collection("products")
      .where("selectedCampaign", "==", campaignId)

      .startAfter(startAfter);
  } else {
    productsCollectionRef = firestore
      .collection("products")
      .where("selectedCampaign", "==", campaignId);
  }
  const products = await productsCollectionRef.get();
  const lastProduct = products.docs[products.docs.length - 1];
  try {
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return { productsArray, lastProduct };
  } catch (error) {
    notifyError(error.message || String(error));
    console.log(error);
  }
};

export const getAllMonthly = async (category, subCategory) => {
  let expensesCollectionRef = null;
  if (
    category == "BUY PRODUCTS" ||
    category == "Boosting" ||
    category == "SHIPPING" ||
    category == "ORDERS" ||
    category == "TRANSPORT" ||
    category == "COURIER" ||
    category == "INVEST"
  ) {
    expensesCollectionRef = firestore
      .collection(`categoryMonthlyExpense`)
      .where("category", "==", category);
  } else {
    expensesCollectionRef = firestore
      .collection(`categoryMonthlyExpense`)
      .where("category", "==", category)
      .where("subCategory", "==", subCategory);
  }

  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getSingleMonthlyCashSummary = async (month) => {
  const expensesCollectionRef = firestore
    .collection("cashSummary")
    .where("month", "==", month);
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getSingleMonthlyCashIn = async (month) => {
  const expensesCollectionRef = firestore
    .collection("dailyCashIn")
    .where("month", "==", month);
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getSingleMonthly = async (month, category, subCategory) => {
  if (category === "INVEST") {
    const expensesCollectionRef = firestore
      .collection("dailyExpenses")
      .where("month", "==", month)
      .where("category", "==", category)
      .where("subCategory", "==", subCategory);
    const cashInCollectionRef = firestore
      .collection("dailyCashIn")
      .where("month", "==", month)
      .where("category", "==", category)
      .where("subCategory", "==", subCategory);
    try {
      const expenses = await expensesCollectionRef.get();
      const cashIns = await cashInCollectionRef.get();
      const expensesArray = [];
      expenses.forEach((doc) => {
        expensesArray.push(doc.data());
      });

      cashIns.forEach((doc) => {
        expensesArray.push(doc.data());
      });
      return expensesArray.sort((a, b) => a.id - b.id);
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else if (
    category == "REFUND" ||
    category == "BUY PRODUCTS" ||
    category == "Boosting" ||
    category == "SHIPPING" ||
    category == "TRANSPORT"
  ) {
    const expensesCollectionRef = firestore
      .collection("dailyExpenses")
      .where("month", "==", month)
      .where("category", "==", category);

    try {
      const expenses = await expensesCollectionRef.get();
      const expensesArray = [];
      expenses.forEach((doc) => {
        expensesArray.push(doc.data());
      });
      return expensesArray;
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else if (category == "ORDERS") {
    const expensesCollectionRef = firestore
      .collection("dailyCashIn")
      .where("month", "==", month)
      .where("category", "==", category);

    try {
      const expenses = await expensesCollectionRef.get();
      const expensesArray = [];
      expenses.forEach((doc) => {
        expensesArray.push(doc.data());
      });
      return expensesArray;
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    const expensesCollectionRef = firestore
      .collection("dailyExpenses")
      .where("month", "==", month)
      .where("category", "==", category)
      .where("subCategory", "==", subCategory);
    try {
      const expenses = await expensesCollectionRef.get();
      const expensesArray = [];
      expenses.forEach((doc) => {
        expensesArray.push(doc.data());
      });
      return expensesArray;
    } catch (error) {
      notifyError(error.message || String(error));
    }
  }
};

export const getSingleMonthlySalary = async (month, category) => {
  const expensesCollectionRef = firestore
    .collection("dailyExpenses")
    .where("month", "==", month)
    .where("category", "==", category);

  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getSingleMonthlyLoanCashIn = async (month, category) => {
  const cashInsCollectionRef = firestore
    .collection("dailyCashIn")
    .where("month", "==", month)
    .where("category", "==", category);

  try {
    const cashIns = await cashInsCollectionRef.get();
    const cashInsArray = [];
    cashIns.forEach((doc) => {
      cashInsArray.push(doc.data());
    });
    return cashInsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getSingleMonthlyLoanCashOut = async (month, category) => {
  const expensesCollectionRef = firestore
    .collection("dailyExpenses")
    .where("month", "==", month)
    .where("category", "==", category);

  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllPendingCashInByDay = async (day) => {
  const cashInsCollectionRef = firestore
    .collection("dailyCashIn")
    .where("date", "==", day)
    .where("status", "==", "pending");
  try {
    const cashIns = await cashInsCollectionRef.get();
    const cashInsArray = [];
    cashIns.forEach((doc) => {
      cashInsArray.push(doc.data());
    });
    return cashInsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllPendingCashIns = async () => {
  const cashInsCollectionRef = firestore
    .collection("dailyCashIn")
    .where("status", "==", "pending");
  try {
    const cashIns = await cashInsCollectionRef.get();
    const cashInsArray = [];
    cashIns.forEach((doc) => {
      cashInsArray.push(doc.data());
    });
    return cashInsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllLoansCashOuts = async () => {
  const expensesCollectionRef = firestore
    .collection("dailyExpenses")
    .where("category", "==", "LOAN");
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllLoansCashIns = async () => {
  const cashInsCollectionRef = firestore
    .collection("dailyCashIn")
    .where("category", "==", "LOAN");
  try {
    const cashIns = await cashInsCollectionRef.get();
    const cashInsArray = [];
    cashIns.forEach((doc) => {
      cashInsArray.push(doc.data());
    });
    return cashInsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllLoansCashOutCustomer = async (customer) => {
  const expensesCollectionRef = firestore
    .collection("dailyExpenses")
    .where("category", "==", "LOAN")
    .where("uid", "==", customer);
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getSingleCustomerLoan = async (customer) => {
  const loanRef = firestore.doc(`customerLoans/${customer}`);
  try {
    const customerLoan = await loanRef.get();
    return customerLoan.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllInstallmentsCashOutCustomer = async (customer) => {
  const expensesCollectionRef = firestore
    .collection("dailyExpenses")
    .where("category", "==", "MONTHLY INSTALLMENT")
    .where("uid", "==", customer);
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllLoansCashInCustomer = async (customer) => {
  const cashInsCollectionRef = firestore
    .collection("dailyCashIn")
    .where("category", "==", "LOAN")
    .where("uid", "==", customer);
  try {
    const cashIns = await cashInsCollectionRef.get();
    const cashInsArray = [];
    cashIns.forEach((doc) => {
      cashInsArray.push(doc.data());
    });
    return cashInsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteCashIn = async (cashId) => {
  const cashInRef = firestore.doc(`dailyCashIn/${cashId}`);
  const snapShot = await cashInRef.get();
  console.log(snapShot.data());
  try {
    await cashInRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteEmployee = async (employeeId) => {
  const employeeRef = firestore.doc(`employees/${employeeId}`);
  const snapShot = await employeeRef.get();
  console.log(snapShot.data());
  try {
    await employeeRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllCustomerLoans = async () => {
  const usersCollectionRef = firestore.collection("customerLoans");
  try {
    const users = await usersCollectionRef.get();
    const usersArray = [];
    users.forEach((doc) => {
      // console.log(doc.id, " => ", doc.data());
      usersArray.push({ uid: doc.id, ...doc.data() });
    });
    return usersArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllCustomerInstallments = async () => {
  const usersCollectionRef = firestore.collection("customerInstallments");
  try {
    const users = await usersCollectionRef.get();
    const usersArray = [];
    users.forEach((doc) => {
      // console.log(doc.id, " => ", doc.data());
      usersArray.push({ uid: doc.id, ...doc.data() });
    });
    return usersArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllCnfs = async () => {
  const cnfsCollectionRef = firestore.collection("cnfs");
  try {
    const cnfs = await cnfsCollectionRef.get();
    const cnfsArray = [];
    cnfs.forEach((doc) => {
      cnfsArray.push(doc.data());
    });
    return cnfsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadCnf = async (cnfObj) => {
  const cnfRef = firestore.doc(`cnfs/${cnfObj.cnfId}`);
  const snapShot = await cnfRef.get();
  if (!snapShot.exists) {
    try {
      await cnfRef.set({
        ...cnfObj,
      });
      console.log(snapShot.data());
      const uploadedSnapShot = await cnfRef.get();
      return uploadedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError(
      "there is already a cnf with similar name, please change the name and try again",
    );
  }
};

export const updateCnf = async (cnfObj) => {
  const cnfRef = firestore.doc(`cnfs/${cnfObj.cnfId}`);
  try {
    await cnfRef.update({ ...cnfObj });
    const snapShot = await cnfRef.get();
    return snapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteCnf = async (cnfId) => {
  const cnfRef = firestore.doc(`cnfs/${cnfId}`);
  const snapShot = await cnfRef.get();
  console.log(snapShot.data());
  try {
    await cnfRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadCnfBill = async (billObj) => {
  const batch = firestore.batch();
  const cnfBillRef = firestore.doc(`cnfBills/${billObj.id}`);
  const cnfBillMonthRef = firestore.doc(`cnfBillMonths/${billObj.month}`);

  // Get the documents
  const cnfBillSnapShot = await cnfBillRef.get();
  const cnfBillMonthSnapShot = await cnfBillMonthRef.get();

  // Check if the bill document exists
  if (!cnfBillSnapShot.exists) {
    try {
      // Set the bill document
      batch.set(cnfBillRef, {
        ...billObj,
      });
      console.log(cnfBillSnapShot.data());
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError("there is already a bill with similar id, please try again later");
  }

  // Check if the bill month document exists
  if (!cnfBillMonthSnapShot.exists) {
    // Set the bill month document
    batch.set(cnfBillMonthRef, { month: billObj.month });
  }

  // Commit the batch
  await batch.commit();

  return true;
};

export const getAllMonthsCnfBill = async (month) => {
  const monthRef = firestore.doc(`cnfBillMonths/${month}`);
  const monthdata = await monthRef.get();

  if (!monthdata.exists) {
    await monthRef.set({
      month: month,
    });
  }

  const monthsCollectionRef = firestore.collection(`cnfBillMonths`);
  try {
    const expenses = await monthsCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllCnfBills = async (month, name) => {
  const cnfsCollectionRef = firestore
    .collection("cnfBills")
    .where("month", "==", month)
    .where("cnf", "==", name);
  try {
    const cnfs = await cnfsCollectionRef.get();
    const cnfsArray = [];
    cnfs.forEach((doc) => {
      cnfsArray.push(doc.data());
    });
    return cnfsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllCnfExpenses = async (month, name) => {
  const expensesCollectionRef = firestore
    .collection("dailyExpenses")
    .where("month", "==", month)
    .where("subCategory", "==", name);
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllCnfBillsAllMonths = async (name) => {
  const cnfsCollectionRef = firestore
    .collection("cnfBills")
    .where("cnf", "==", name);
  try {
    const cnfs = await cnfsCollectionRef.get();
    const cnfsArray = [];
    cnfs.forEach((doc) => {
      cnfsArray.push(doc.data());
    });
    return cnfsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllCnfExpensesAllMonths = async (name) => {
  const expensesCollectionRef = firestore
    .collection("dailyExpenses")
    .where("subCategory", "==", name);
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const updateEmployee = async (employeeObj) => {
  const employeeRef = firestore.doc(`employees/${employeeObj.employeeId}`);
  try {
    await employeeRef.update({ ...employeeObj });
    const snapShot = await employeeRef.get();
    return snapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const updateSalary = async (employee) => {
  const categoryMonthlyExpenseRef = firestore.doc(
    `categoryMonthlyExpense/${employee.id}`,
  );
  const categoryMonthlyExpnese = await categoryMonthlyExpenseRef.get();
  await categoryMonthlyExpenseRef.update({
    ...categoryMonthlyExpnese.data(),
    salary: employee.salary,
  });
  const updatedSnapShot = await categoryMonthlyExpenseRef.get();
  return updatedSnapShot.data();
};

export const uploadEmployee = async (employeeObj) => {
  const employeeRef = firestore.doc(`employees/${employeeObj.employeeId}`);
  const snapShot = await employeeRef.get();
  if (!snapShot.exists) {
    try {
      await employeeRef.set({
        ...employeeObj,
      });
      console.log(snapShot.data());
      const uploadedSnapShot = await employeeRef.get();
      return uploadedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError(
      "there is already a employee with similar name, please change the name and try again",
    );
  }
};

export const getAllFunds = async () => {
  const expensesCollectionRef = firestore
    .collection(`dailyExpenses`)
    .where("category", "==", "FUND");

  const cashInCollectionRef = firestore
    .collection(`dailyCashIn`)
    .where("category", "==", "FUND");

  try {
    const expenses = await expensesCollectionRef.get();
    const cashIns = await cashInCollectionRef.get();
    const expensesArray = [];
    const cashInsArray = [];
    cashIns.forEach((doc) => {
      cashInsArray.push({ ...doc.data(), type: "cashIn" });
    });
    expenses.forEach((doc) => {
      expensesArray.push({ ...doc.data(), type: "expense" });
    });
    let mergedArray = [...expensesArray, ...cashInsArray];
    return mergedArray.sort((a, b) => parseInt(a.id) - parseInt(b.id));
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllCashIns = async (day) => {
  const expensesCollectionRef = firestore
    .collection("dailyCashIn")
    .where("date", "==", day);
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};
export const getAllCashInsInvest = async (name) => {
  const expensesCollectionRef = firestore
    .collection("dailyCashIn")
    .where("subCategory", "==", name);
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });
    return expensesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const createMonth = async () => {
  const date = new Date();
  const monthRef = firestore.doc(`months/${getMonthName()}`);
  const month = await monthRef.get();
  if (month.exists) {
    let monthsArray = [];
    const monthsCollectionRef = firestore.collection("months");
    const monthsCollection = await monthsCollectionRef.get();
    monthsCollection.forEach((doc) => {
      monthsArray.push(doc.data());
    });
    return monthsArray;
  } else {
    await monthRef.set({
      month: getMonthName(),
    });
    let monthsArray = [];
    const monthsCollectionRef = firestore.collection("months");
    const monthsCollection = await monthsCollectionRef.get();
    monthsCollection.forEach((doc) => {
      monthsArray.push(doc.data());
    });
    return monthsArray;
  }
};
export const getMonthName = () => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const d = new Date();
  return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
};

export const getAllSourcingMonthStats = async () => {
  try {
    const snapshot = await firestore.collection("sourcingMonthStats").get();
    const statsArray = [];
    snapshot.forEach((doc) => {
      statsArray.push(doc.data());
    });
    return statsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

// Idempotently creates the current month's stats doc (all zero) so it's
// visible in the months list even before its first invoice.
export const ensureCurrentMonthStats = async () => {
  const ref = monthStatsRef(getMonthName());
  try {
    const snap = await ref.get();
    if (!snap.exists) {
      await ref.set({
        month: getMonthName(),
        invoiceCount: 0,
        totalBill: 0,
        totalPaid: 0,
        totalBuyingCost: 0,
        totalAgentProfit: 0,
        totalProfit: 0,
        totalZapaiProfit: 0,
        totalRefundGiven: 0,
        totalRefundTaken: 0,
        byAgent: {},
      });
    }
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

// One-time/manual backfill — full scan of the `sourcing` collection,
// grouped by month + agent, overwriting (not incrementing) each
// sourcingMonthStats doc. Not part of any normal page-load path; run once
// to seed historical months that predate this feature.
export const recomputeSourcingMonthStats = async () => {
  try {
    const snapshot = await firestore.collection("sourcing").get();
    const byMonth = {};
    snapshot.forEach((doc) => {
      const s = doc.data();
      if (!s.month) return;
      if (!byMonth[s.month]) {
        byMonth[s.month] = {
          month: s.month,
          invoiceCount: 0,
          totalBill: 0,
          totalPaid: 0,
          totalBuyingCost: 0,
          totalAgentProfit: 0,
          totalProfit: 0,
          totalZapaiProfit: 0,
          totalRefundGiven: 0,
          totalRefundTaken: 0,
          byAgent: {},
        };
      }
      const bucket = byMonth[s.month];
      const addTo = (target) => {
        target.invoiceCount += 1;
        target.totalBill += parseFloat(s.totalBill) || 0;
        target.totalPaid += parseFloat(s.totalPaid) || 0;
        target.totalBuyingCost += parseFloat(s.buyingCost) || 0;
        target.totalAgentProfit += parseFloat(s.agentPaid) || 0;
        target.totalProfit += parseFloat(s.finalProfit) || 0;
        target.totalZapaiProfit += parseFloat(s.algProfit) || 0;
        target.totalRefundGiven += sumRefundArray(s.givenRefund);
        target.totalRefundTaken +=
          sumRefundArray(s.receivedRefund) * (parseFloat(s.buyRate) || 0);
      };
      addTo(bucket);
      if (s.agent) {
        if (!bucket.byAgent[s.agent]) {
          bucket.byAgent[s.agent] = {
            invoiceCount: 0,
            totalBill: 0,
            totalPaid: 0,
            totalBuyingCost: 0,
            totalAgentProfit: 0,
            totalProfit: 0,
            totalZapaiProfit: 0,
            totalRefundGiven: 0,
            totalRefundTaken: 0,
          };
        }
        addTo(bucket.byAgent[s.agent]);
      }
    });
    const batch = firestore.batch();
    Object.values(byMonth).forEach((doc) => {
      batch.set(monthStatsRef(doc.month), doc);
    });
    await batch.commit();
    return Object.values(byMonth);
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

// Approves every pending item in `expenses` (all dailyCashIn docs for one
// day) as a single atomic operation, together with the day's cash summary —
// same rationale and grouping strategy as approveExpensesBatch above (see
// its comment); mirrors the old approveCashIn's category branches exactly
// (LOAN subtracts from the customer's loan balance — intentional, cash
// coming in reduces what they owe; ORDERS accumulates into
// categoryMonthlyExpense; anything else only touches monthlyCashIn).
export const approveCashInsBatch = async (expenses, { month, date, total }) => {
  if (!expenses || expenses.length === 0) {
    return { success: true, approvedIds: [] };
  }

  try {
    // Phase A
    const expenseRefs = expenses.map((e) => firestore.doc(`dailyCashIn/${e.id}`));
    const expenseSnaps = await Promise.all(expenseRefs.map((ref) => ref.get()));

    for (let i = 0; i < expenseSnaps.length; i++) {
      if (!expenseSnaps[i].exists || expenseSnaps[i].data().status !== "pending") {
        return {
          success: false,
          reason: "stale-item",
          message: `"${expenses[i].subCategory || expenses[i].note || expenses[i].id}" is no longer pending — nothing was approved.`,
          approvedIds: [],
        };
      }
    }
    const resolved = expenseSnaps.map((snap) => ({ id: snap.id, ...snap.data() }));

    // Phase B — group by target document, summing deltas.
    const targets = new Map();
    const addTarget = (ref, amount, kind, meta) => {
      const key = ref.path;
      if (!targets.has(key)) targets.set(key, { ref, deltaAmount: 0, kind, meta });
      const entry = targets.get(key);
      entry.deltaAmount += amount;
      entry.meta = meta;
    };

    resolved.forEach((expense) => {
      const amount = parseInt(expense.amount) || 0;

      if (expense.category === "LOAN") {
        addTarget(
          firestore.doc(`customerLoans/${expense.uid}`),
          -amount, // cash in reduces the loan balance
          "customer",
          { customer: expense.subCategory, uid: expense.uid },
        );
      } else if (expense.category === "ORDERS") {
        const categoryMonthlyExpenseId = `${expense.month}-${expense.category}`;
        addTarget(
          firestore.doc(`categoryMonthlyExpense/${categoryMonthlyExpenseId}`),
          amount,
          "categoryMonthlyExpense",
          {
            id: categoryMonthlyExpenseId, // fixed: was previously written including subCategory, which never matched this doc's actual (subCategory-agnostic) key
            category: expense.category,
            subCategory: expense.subCategory,
            month: expense.month,
          },
        );
      }

      addTarget(firestore.doc(`monthlyCashIn/${expense.month}`), amount, "monthlyExpense", {
        id: expense.month,
      });
    });

    // Phase C
    const targetEntries = Array.from(targets.values());
    const targetSnaps = await Promise.all(targetEntries.map((t) => t.ref.get()));

    const cashSummaryCtx = await readCashSummaryContext(date);

    const estimatedOps =
      resolved.length + targetEntries.length + 1 + cashSummaryCtx.forwardDayRefs.length;
    if (estimatedOps > APPROVAL_BATCH_OP_LIMIT) {
      return {
        success: false,
        reason: "too-many-items",
        message: `Too many pending items to approve atomically at once (${estimatedOps} operations). Please approve in smaller groups.`,
        approvedIds: [],
      };
    }

    // Phase D
    const batch = firestore.batch();

    resolved.forEach((expense) => {
      batch.update(firestore.doc(`dailyCashIn/${expense.id}`), { status: "approved" });
    });

    targetEntries.forEach((entry, i) => {
      const snap = targetSnaps[i];
      const existingAmount = snap.exists ? parseInt(snap.data().amount) || 0 : 0;
      const newAmount = existingAmount + entry.deltaAmount;

      if (entry.kind === "categoryMonthlyExpense") {
        if (snap.exists) {
          batch.update(entry.ref, { amount: newAmount });
        } else {
          batch.set(entry.ref, {
            id: entry.meta.id,
            amount: newAmount,
            category: entry.meta.category,
            subCategory: entry.meta.subCategory,
            month: entry.meta.month,
            paid: false,
            salary: 0,
          });
        }
      } else if (entry.kind === "customer") {
        if (snap.exists) {
          batch.update(entry.ref, { amount: newAmount, customer: entry.meta.customer });
        } else {
          batch.set(entry.ref, {
            customer: entry.meta.customer,
            amount: newAmount,
            uid: entry.meta.uid,
          });
        }
      } else if (entry.kind === "monthlyExpense") {
        if (snap.exists) {
          batch.update(entry.ref, { amount: newAmount });
        } else {
          batch.set(entry.ref, { id: entry.meta.id, amount: newAmount });
        }
      }
    });

    // Phase E — cash-in adds to remainingBalance (opposite sign from
    // approveExpensesBatch's cash-out), matching updateCashSummaryCashIn.
    queueCashSummaryWrites(batch, cashSummaryCtx, {
      month,
      date,
      total,
      sign: 1,
      totalsField: "totalCashIns",
    });

    // Phase F
    await batch.commit();
    return { success: true, approvedIds: resolved.map((e) => e.id) };
  } catch (error) {
    console.error("Error approving cash-ins:", error);
    return {
      success: false,
      reason: "batch-commit-failure",
      message: error.message || "Failed to approve cash-ins — nothing was changed.",
      approvedIds: [],
    };
  }
};

export const createSalaryMonth = async (month, employee) => {
  const categoryMonthlyExpenseRef = firestore.doc(
    `categoryMonthlyExpense/${month}-SALARY-${employee.name}`,
  );
  const categoryMonthlyExpnese = await categoryMonthlyExpenseRef.get();
  if (!categoryMonthlyExpnese.exists) {
    await categoryMonthlyExpenseRef.set({
      id: `${month}-SALARY-${employee.name}`,
      amount: 0,
      category: "SALARY",
      subCategory: employee.name,
      month: month,
      paid: false,
      salary: 0,
    });
  }
};

export const getMonth = async (employee, month) => {
  const expensesCollectionRef = firestore
    .collection(`categoryMonthlyExpense`)
    .where("category", "==", "SALARY")
    .where("subCategory", "==", employee);
  try {
    const expenses = await expensesCollectionRef.get();
    const expensesArray = [];
    expenses.forEach((doc) => {
      expensesArray.push(doc.data());
    });

    const unPaidMonths = expensesArray.filter((expense) => !expense.paid);
    return unPaidMonths;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

// updateCashSummaryCashOut/CashIn were folded into approveExpensesBatch/
// approveCashInsBatch above (see queueCashSummaryWrites/readCashSummaryContext)
// so the whole approval + cash-summary update commits as one atomic batch —
// they had exactly one caller each (the approve action) and are no longer
// called standalone.

export const getAllScreenShot = async () => {
  const cnfsCollectionRef = firestore.collection("screenshots");
  try {
    const cnfs = await cnfsCollectionRef.get();
    const cnfsArray = [];
    cnfs.forEach((doc) => {
      cnfsArray.push(doc.data());
    });
    return cnfsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadScreenShot = async (cnfObj) => {
  const cnfRef = firestore.doc(`screenshots/${cnfObj.id}`);
  const snapShot = await cnfRef.get();
  if (!snapShot.exists) {
    try {
      await cnfRef.set({
        ...cnfObj,
      });
      console.log(snapShot.data());
      const uploadedSnapShot = await cnfRef.get();
      return uploadedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError(
      "there is already a cnf with similar name, please change the name and try again",
    );
  }
};

export const updateScreenShot = async (cnfObj) => {
  const cnfRef = firestore.doc(`screenshots/${cnfObj.id}`);
  try {
    await cnfRef.update({ ...cnfObj });
    const snapShot = await cnfRef.get();
    return snapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteScreenShot = async (cnfId) => {
  const cnfRef = firestore.doc(`screenshots/${cnfId}`);
  const snapShot = await cnfRef.get();
  console.log(snapShot.data());
  try {
    await cnfRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllTransactions = async (productId, month) => {
  const employeesCollectionRef = firestore
    .collection("transactions")
    .where("productId", "==", productId)
    .where("month", "==", month);
  try {
    const employees = await employeesCollectionRef.get();
    const employeesArray = [];
    employees.forEach((doc) => {
      employeesArray.push(doc.data());
    });
    return employeesArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllTransactionsAllTime = async (productId) => {
  try {
    const snap = await firestore
      .collection("transactions")
      .where("productId", "==", productId)
      .get();
    return snap.docs.map((doc) => doc.data());
  } catch (error) {
    notifyError(error.message || String(error));
    return [];
  }
};

const updateProductStats = async (productId, soldDelta, revenueDelta) => {
  try {
    const statsRef = firestore.doc(`productStats/${productId}`);
    await statsRef.set(
      {
        productId,
        totalSold: firebase.firestore.FieldValue.increment(soldDelta),
        totalRevenue: firebase.firestore.FieldValue.increment(revenueDelta || 0),
      },
      { merge: true },
    );
  } catch (error) {
    console.error("productStats update failed:", error);
  }
};

export const uploadTransaction = async (transactionObj) => {
  const transactionRef = firestore.doc(`transactions/${transactionObj.id}`);
  const snapShot = await transactionRef.get();
  if (!snapShot.exists) {
    try {
      await transactionRef.set({
        ...transactionObj,
      });

      if (transactionObj.productId) {
        if (transactionObj.fundType === "Selling") {
          await updateProductStats(
            transactionObj.productId,
            parseInt(transactionObj.sellStock) || 0,
            parseInt(transactionObj.totalBill) || 0,
          );
        } else if (
          transactionObj.fundType === "Buying" &&
          (transactionObj.orderStatus === "Cancelled" ||
            transactionObj.purchasePrice === "Partial delivered")
        ) {
          const qty = parseInt(transactionObj.productStock) || 0;
          const revenue =
            transactionObj.orderStatus === "Cancelled"
              ? -(parseInt(transactionObj.totalCost) || 0)
              : 0;
          await updateProductStats(transactionObj.productId, -qty, revenue);
        }
      }

      const uploadedSnapShot = await transactionRef.get();
      return uploadedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError(
      "there is already a transaction with similar name, please change the name and try again",
    );
  }
};

export const backfillProductStats = async () => {
  const snap = await firestore.collection("transactions").get();
  const stats = {};

  snap.docs.forEach((doc) => {
    const t = doc.data();
    if (!t.productId) return;
    if (!stats[t.productId])
      stats[t.productId] = { totalSold: 0, totalRevenue: 0 };

    if (t.fundType === "Selling") {
      stats[t.productId].totalSold += parseInt(t.sellStock) || 0;
      stats[t.productId].totalRevenue += parseInt(t.totalBill) || 0;
    } else if (
      t.fundType === "Buying" &&
      (t.orderStatus === "Cancelled" ||
        t.purchasePrice === "Partial delivered")
    ) {
      stats[t.productId].totalSold -= parseInt(t.productStock) || 0;
      if (t.orderStatus === "Cancelled") {
        stats[t.productId].totalRevenue -= parseInt(t.totalCost) || 0;
      }
    }
  });

  const batch = firestore.batch();
  Object.entries(stats).forEach(([productId, data]) => {
    const ref = firestore.doc(`productStats/${productId}`);
    batch.set(ref, { productId, ...data });
  });
  await batch.commit();
};

export const getAllProductStats = async () => {
  const snap = await firestore
    .collection("productStats")
    .orderBy("totalSold", "desc")
    .get();
  return snap.docs.map((doc) => doc.data());
};

export const updateTransaction = async (transactionObj) => {
  const transactionRef = firestore.doc(`transactions/${transactionObj.id}`);
  try {
    await transactionRef.update({ ...transactionObj });
    const snapShot = await transactionRef.get();
    return snapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteTransaction = async (id) => {
  const transactionRef = firestore.doc(`transactions/${id}`);
  const snapShot = await transactionRef.get();
  console.log(snapShot.data());
  try {
    await transactionRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const addCreatedAtInBatches = async () => {
  const batchSize = 20;
  let lastDoc = null;
  let totalUpdated = 0;
  let hasMore = true;

  while (hasMore) {
    let query = firestore
      .collection("orders")
      .orderBy(firebase.firestore.FieldPath.documentId())
      .limit(batchSize);

    if (lastDoc) {
      query = query.startAfter(lastDoc);
    }

    const snapshot = await query.get();
    if (snapshot.empty) {
      console.log("✅ No more documents to update.");
      break;
    }
    const batch = firestore.batch();
    let updateCount = 0;

    snapshot.docs.forEach((docSnap) => {
      const data = docSnap.data();
      if (!data.createdAt) {
        const docRef = firestore.collection("orders").doc(docSnap.id);
        batch.update(docRef, {
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        });
        updateCount++;
      }
    });

    if (updateCount > 0) {
      await batch.commit();
      totalUpdated += updateCount;
      console.log(`✅ Updated ${updateCount} documents in this batch.`);
    } else {
      console.log(`ℹ️ No updates needed in this batch.`);
    }

    lastDoc = snapshot.docs[snapshot.docs.length - 1];
    hasMore = snapshot.size === batchSize;
  }

  console.log(`🎉 Finished. Total documents updated: ${totalUpdated}`);
};

export const getAllPartials = async () => {
  const productsCollectionRef = firestore.collection("partial-payments");
  try {
    const products = await productsCollectionRef.get();
    const productsArray = [];
    products.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadPartial = async (productObj) => {
  const productsRef = firestore.collection("partial-payments");
  const products = await productsRef.get();
  products.forEach(async (doc) => {
    const proRef = firestore.doc(`partial-payments/${doc.id}`);
    await proRef.delete();
  });
  const productRef = firestore.doc(`partial-payments/${productObj.id}`);
  const snapShot = await productRef.get();
  const newProductObj = { ...productObj, file: "" };
  if (!snapShot.exists) {
    try {
      await productRef.set({ ...newProductObj });
      const updatedSnapShot = await productRef.get();
      return updatedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError("there is already a partial payment with similar id");
  }
};

export const updatePartial = async (productObj) => {
  const productRef = firestore.doc(`partial-payments/${productObj.id}`);
  try {
    delete productObj.file;
    await productRef.update({ ...productObj });
    const updatedSnapShot = await productRef.get();
    return updatedSnapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deletePartial = async (id) => {
  const productRef = firestore.doc(`partial-payments/${id}`);
  try {
    await productRef.delete();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const get1688PaymentsByDateRange = async (
  startDate,
  endDate,
  linkStatus,
  rmbStatus,
) => {
  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);
  const end = new Date(endDate);
  end.setHours(23, 59, 59, 999);
  const startTs = firebase.firestore.Timestamp.fromDate(start);
  const endTs = firebase.firestore.Timestamp.fromDate(end);
  let query = firebase
    .firestore()
    .collection("paymentLinks1688")
    .where("createdAt", ">=", startTs)
    .where("createdAt", "<=", endTs);
  if (linkStatus && linkStatus.trim() !== "") {
    query = query.where("linkStatus", "==", linkStatus);
  }
  if (rmbStatus && rmbStatus.trim() !== "") {
    query = query.where("rmbStatus", "==", rmbStatus);
  }
  const snapshot = await query.get();
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const getSinglePayment1688 = async (paymentId) => {
  try {
    const ref = firestore.doc(`paymentLinks1688/${paymentId}`);
    const snap = await ref.get();
    return snap.data();
  } catch (error) {
    notifyError(error.message || String(error));
    return null;
  }
};

export const updatepaymentLink1688 = async (
  paymentObj,
  rmbRate,
  totalRmb,
  imageUrl,
) => {
  try {
    const batch = firebase.firestore().batch();
    const paymentLinksRef = firebase
      .firestore()
      .collection("paymentLinks1688")
      .doc(paymentObj.paymentId);
    batch.update(paymentLinksRef, {
      rmbStatus: "Paid",
      rmbRate,
      totalRmbPaid: totalRmb,
      receipt: imageUrl,
    });
    paymentObj.orders.forEach((order) => {
      const orderRef = firebase
        .firestore()
        .collection("ordersApi")
        .doc(`${order.orderId}`);
      batch.update(orderRef, { exchangeRate: rmbRate });
    });
    let date = new Date();
    let expenseObj = {
      id: `${date.getTime().toString()}`,
      category: "RMB",
      subCategory: "1688 Orders",
      month: getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      note: `Payment Id: ${paymentObj.paymentId}, Total Rmb: ${totalRmb}, rmb Rate:${rmbRate}`,
      amount: parseInt(totalRmb * rmbRate),
      receiveBy: "admin",
      status: "pending",
      unEditable: true,
    };
    const expenseRef = firestore.doc(`dailyExpenses/${expenseObj.id}`);
    batch.set(expenseRef, expenseObj);
    await batch.commit();
    return paymentObj;
  } catch (error) {
    return null;
  }
};

export const updatepaymentLink = async (paymentObj) => {
  try {
    const batch = firebase.firestore().batch();
    const paymentLinksRef = firebase
      .firestore()
      .collection("paymentLinks1688")
      .doc(paymentObj.paymentId);
    batch.update(paymentLinksRef, { paymentLink: paymentObj.paymentLink });
    await batch.commit();
    return paymentObj;
  } catch (error) {
    return null;
  }
};

export const updateOrdersWithPaymentLink = async (
  totalRmb,
  orders,
  paymentLink,
) => {
  try {
    const batch = firebase.firestore().batch();
    const paymentLinkId = Date.now().toString();
    const paymentLinksRef = firebase
      .firestore()
      .collection("paymentLinks1688")
      .doc(paymentLinkId);
    batch.set(paymentLinksRef, {
      createdAt: firebase.firestore.Timestamp.now(),
      paymentId: paymentLinkId,
      date: new Date().toLocaleDateString("en-GB"),
      paymentLink,
      totalRmb,
      linkStatus: "Not Paid",
      rmbStatus: "Not Paid",
      orders,
    });
    orders.forEach((order) => {
      const orderRef = firebase
        .firestore()
        .collection("ordersApi")
        .doc(`${order.orderId}`);
      batch.update(orderRef, { paymentLink1688: paymentLink, paymentLinkId });
    });
    await batch.commit();
    return orders;
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const getSingleUser = async (id) => {
  const userRef = firestore.doc(`users/${id}`);
  try {
    const user = await userRef.get();
    return user.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getSingleOrderApi = async (id) => {
  const orderRef = firestore.doc(`ordersApi/${id}`);
  try {
    const order = await orderRef.get();
    return normalizeOrderApiDoc(order.data());
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getSingleProductRequest = async (id) => {
  const orderRef = firestore.doc(`bookingRequest/${id}`);
  try {
    const order = await orderRef.get();
    return order.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

let totalUploaded1688 = 0;

export const upload1688Category = async (category) => {
  const productRef = firestore.doc(`1688Category/${category.categoryId}`);
  const snapShot = await productRef.get();
  if (!snapShot.exists) {
    try {
      productRef.set({
        ...category,
        level1: firebase.firestore.FieldValue.arrayUnion(category.categoryId),
      });
      totalUploaded1688 += 1;
    } catch (error) {
      notifyError(error.message || String(error));
    }
  }
};

export const addToRootCategory = async (category) => {
  const productRef = firestore.doc(`1688Category/${category.parentCateId}`);
  const snapShot = await productRef.get();
  if (snapShot.exists) {
    try {
      productRef.update({
        level2: firebase.firestore.FieldValue.arrayUnion(category.categoryId),
      });
      totalUploaded1688 += 1;
    } catch (error) {
      notifyError(error.message || String(error));
    }
  }
};

export const level3Category = async (category) => {
  const querySnapshot = await firestore
    .collection("1688Category")
    .where("level2", "array-contains", category.parentCateId)
    .get();
  for (let doc of querySnapshot.docs) {
    await doc.ref.update({
      level3: firebase.firestore.FieldValue.arrayUnion(category.categoryId),
    });
  }
  totalUploaded1688 += 1;
};

export const bulkUpdateOrderStatus = async (ids, orderStatus) => {
  const oldSnaps = await Promise.all(ids.map((id) => firestore.doc(`ordersList/${id}`).get()));
  const batch = firestore.batch();
  const numDelta = {};
  const dailyNumDeltas = {}; // dayDocPath → { ref, n: { count, totalBill, ... } }

  ids.forEach((id, i) => {
    batch.update(firestore.doc(`orders/${id}`), { orderStatus });
    batch.set(firestore.doc(`ordersList/${id}`), { orderStatus }, { merge: true });
    const old = oldSnaps[i].data() || {};
    const oldStatus = old.orderStatus || "";
    const bill = old.totalBill || 0, paid = old.totalPaid || 0, disc = old.finalDiscount || 0;

    // Status summary delta
    if (oldStatus && oldStatus !== orderStatus) {
      numDelta[`${oldStatus}.count`]         = (numDelta[`${oldStatus}.count`]         || 0) - 1;
      numDelta[`${oldStatus}.totalBill`]     = (numDelta[`${oldStatus}.totalBill`]     || 0) - bill;
      numDelta[`${oldStatus}.totalPaid`]     = (numDelta[`${oldStatus}.totalPaid`]     || 0) - paid;
      numDelta[`${oldStatus}.totalDiscount`] = (numDelta[`${oldStatus}.totalDiscount`] || 0) - disc;
    }
    numDelta[`${orderStatus}.count`]         = (numDelta[`${orderStatus}.count`]         || 0) + 1;
    numDelta[`${orderStatus}.totalBill`]     = (numDelta[`${orderStatus}.totalBill`]     || 0) + bill;
    numDelta[`${orderStatus}.totalPaid`]     = (numDelta[`${orderStatus}.totalPaid`]     || 0) + paid;
    numDelta[`${orderStatus}.totalDiscount`] = (numDelta[`${orderStatus}.totalDiscount`] || 0) + disc;

    // Daily doc delta — accumulate per day (orders created same day share one doc)
    const dRef = dayDocRef(old.createdAt);
    if (dRef) {
      const path = dRef.path;
      if (!dailyNumDeltas[path]) dailyNumDeltas[path] = { ref: dRef, n: { count: 0, totalBill: 0, totalPaid: 0, totalDiscount: 0, cancelledCount: 0, cancelledBill: 0 } };
      const nd = dailyNumDeltas[path].n;
      const oldCancelled = oldStatus === "Cancelled";
      const newCancelled = orderStatus === "Cancelled";
      if (oldCancelled) { nd.cancelledCount -= 1; nd.cancelledBill -= bill; }
      else              { nd.count -= 1; nd.totalBill -= bill; nd.totalPaid -= paid; nd.totalDiscount -= disc; }
      if (newCancelled) { nd.cancelledCount += 1; nd.cancelledBill += bill; }
      else              { nd.count += 1; nd.totalBill += bill; nd.totalPaid += paid; nd.totalDiscount += disc; }
    }
  });

  // Apply status summary update
  const summaryUpdate = {};
  Object.entries(numDelta).forEach(([k, v]) => { summaryUpdate[k] = inc(v); });
  try { batch.update(SUMMARY_DOC(), summaryUpdate); } catch (_) {}

  // Apply daily doc updates (one batch.set per distinct creation day)
  Object.values(dailyNumDeltas).forEach(({ ref, n }) => {
    const delta = {};
    Object.entries(n).forEach(([k, v]) => { if (v !== 0) delta[k] = inc(v); });
    if (Object.keys(delta).length > 0) batch.set(ref, delta, { merge: true });
  });

  await batch.commit();
};

// ── Refund Requests ──────────────────────────────────────────────────────────

export const getRefundRequests = async (status, lastCreatedAt = null, pageSize = 15) => {
  try {
    let query = firestore
      .collection("refund-requests")
      .where("refundStatus", "==", status)
      .orderBy("createdAt", "desc")
      .limit(pageSize);

    if (lastCreatedAt) {
      query = query.startAfter(lastCreatedAt);
    }

    const snapshot = await query.get();
    const docs = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    const lastDoc = snapshot.docs[snapshot.docs.length - 1];
    return {
      docs,
      lastCreatedAt: lastDoc ? lastDoc.data().createdAt : null,
      hasMore: snapshot.size === pageSize,
    };
  } catch (error) {
    console.error("getRefundRequests error:", error);
    return { docs: [], lastCreatedAt: null, hasMore: false };
  }
};

export const getAllPendingRefundRequests = async () => {
  try {
    const snapshot = await firestore
      .collection("refund-requests")
      .where("refundStatus", "==", "pending")
      .orderBy("createdAt", "desc")
      .get();
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("getAllPendingRefundRequests error:", error);
    return [];
  }
};

export const updateRefundStatus = async (id, status, adminNote = "", refundedAmount = null, orderId = null) => {
  const payload = { refundStatus: status, updatedAt: Date.now() };
  if (adminNote) payload.adminNote = adminNote;
  if (status === "approve" && refundedAmount != null) {
    payload.refundedAmount = Number(refundedAmount);
  }
  if (status === "approve" && refundedAmount != null && orderId) {
    const amt = Number(refundedAmount);
    const batch = firestore.batch();
    batch.update(firestore.doc(`refund-requests/${id}`), payload);
    batch.update(firestore.doc(`orders/${orderId}`), { refundedAmount: amt });
    batch.set(firestore.doc(`ordersList/${orderId}`), { refundedAmount: amt }, { merge: true });
    await batch.commit();
  } else {
    await firestore.doc(`refund-requests/${id}`).update(payload);
  }
};

export const buildOrderSummary = async (onProgress) => {
  const KNOWN_STATUSES = [
    "Processing", "Confirmed", "Packing", "On the way",
    "Delivered", "Partial Delivered", "Cancelled",
  ];
  const totals = {};
  KNOWN_STATUSES.forEach((s) => {
    totals[s] = { count: 0, totalBill: 0, totalPaid: 0, totalDiscount: 0 };
  });
  const dailyAcc = {}; // dayDocPath → { ref, count, totalBill, totalPaid, totalDiscount, cancelledCount, cancelledBill }

  let lastDoc = null;
  let total = 0;
  const BATCH_SIZE = 100;
  while (true) {
    let q = firestore
      .collection("ordersList")
      .orderBy(firebase.firestore.FieldPath.documentId())
      .limit(BATCH_SIZE);
    if (lastDoc) q = q.startAfter(lastDoc);
    const snap = await q.get();
    if (snap.empty) break;
    snap.docs.forEach((doc) => {
      const d = doc.data();
      const status = d.orderStatus || "Unknown";
      // Status summary
      if (!totals[status]) totals[status] = { count: 0, totalBill: 0, totalPaid: 0, totalDiscount: 0 };
      totals[status].count         += 1;
      totals[status].totalBill     += d.totalBill     || 0;
      totals[status].totalPaid     += d.totalPaid     || 0;
      totals[status].totalDiscount += d.finalDiscount || 0;
      // Daily summary
      const dRef = dayDocRef(d.createdAt);
      if (dRef) {
        const key = dRef.path;
        if (!dailyAcc[key]) dailyAcc[key] = { ref: dRef, count: 0, totalBill: 0, totalPaid: 0, totalDiscount: 0, cancelledCount: 0, cancelledBill: 0 };
        const acc = dailyAcc[key];
        if (status === "Cancelled") { acc.cancelledCount += 1; acc.cancelledBill += d.totalBill || 0; }
        else { acc.count += 1; acc.totalBill += d.totalBill || 0; acc.totalPaid += d.totalPaid || 0; acc.totalDiscount += d.finalDiscount || 0; }
      }
    });
    total += snap.docs.length;
    lastDoc = snap.docs[snap.docs.length - 1];
    if (onProgress) onProgress(total);
    if (snap.docs.length < BATCH_SIZE) break;
  }

  // Write status summary doc
  await SUMMARY_DOC().set(totals);

  // Write daily docs in chunks of 490 (Firestore batch limit is 500)
  const dailyEntries = Object.values(dailyAcc);
  for (let i = 0; i < dailyEntries.length; i += 490) {
    const chunk = dailyEntries.slice(i, i + 490);
    const batch = firestore.batch();
    chunk.forEach(({ ref, ...data }) => batch.set(ref, data));
    await batch.commit();
  }

  return total;
};

export const countCollection = async (collectionId) => {
  const user = firebase.auth().currentUser;
  if (!user) throw new Error("Not authenticated");
  const token = await user.getIdToken();
  const res = await fetch(
    `https://firestore.googleapis.com/v1/projects/zapai-8585e/databases/(default)/documents:runAggregationQuery`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({
        structuredAggregationQuery: {
          structuredQuery: { from: [{ collectionId }] },
          aggregations: [{ count: {}, alias: "count" }],
        },
      }),
    }
  );
  const data = await res.json();
  return parseInt(data[0]?.result?.aggregateFields?.count?.integerValue || 0);
};

export const sumOrdersList = async (startTs = null, endTs = null, orderStatus = null) => {
  const isAllOrders = !orderStatus || orderStatus === "All Orders";
  const hasDateRange = startTs != null && endTs != null;

  // Status tab, no date range → single read from summary doc
  if (!isAllOrders && !hasDateRange) {
    const snap = await SUMMARY_DOC().get();
    const s = (snap.data() || {})[orderStatus] || {};
    const totalBill = Math.round(s.totalBill || 0);
    const totalPaid = Math.round(s.totalPaid || 0);
    return {
      orderCount:    s.count        || 0,
      totalBill,
      totalPaid,
      totalDue:      Math.max(0, totalBill - totalPaid),
      totalDiscount: Math.round(s.totalDiscount || 0),
      cancelledCount: 0,
      cancelledBill:  0,
    };
  }

  // Date range → read daily summary docs (N reads where N = number of days in range)
  if (hasDateRange && isAllOrders) {
    const dayKeys = getDayKeys(startTs, endTs);
    const snaps = await Promise.all(dayKeys.map((k) => firestore.doc(`summaries/${k}`).get()));
    let orderCount = 0, cancelledCount = 0;
    let totalBill = 0, totalPaid = 0, totalDiscount = 0, cancelledBill = 0;
    snaps.forEach((snap) => {
      if (!snap.exists) return;
      const d = snap.data();
      orderCount     += d.count          || 0;
      totalBill      += d.totalBill      || 0;
      totalPaid      += d.totalPaid      || 0;
      totalDiscount  += d.totalDiscount  || 0;
      cancelledCount += d.cancelledCount || 0;
      cancelledBill  += d.cancelledBill  || 0;
    });
    totalBill = Math.round(totalBill);
    totalPaid = Math.round(totalPaid);
    return {
      orderCount,
      totalBill,
      totalPaid,
      totalDue:      Math.max(0, totalBill - totalPaid),
      totalDiscount: Math.round(totalDiscount),
      cancelledCount,
      cancelledBill: Math.round(cancelledBill),
    };
  }

  // Status tab + date range (rare): SDK query filtered client-side
  let query = firestore.collection("ordersList");
  if (hasDateRange) {
    query = query
      .where("createdAt", ">=", firebase.firestore.Timestamp.fromMillis(startTs))
      .where("createdAt", "<=", firebase.firestore.Timestamp.fromMillis(endTs));
  }
  const snapshot = await query.get();
  let orderCount = 0, cancelledCount = 0;
  let totalBill = 0, totalPaid = 0, totalDiscount = 0, cancelledBill = 0;
  snapshot.docs.forEach((doc) => {
    const d = doc.data();
    if (!isAllOrders && d.orderStatus !== orderStatus) return;
    if (d.orderStatus === "Cancelled") { cancelledCount++; cancelledBill += d.totalBill || 0; }
    else { orderCount++; totalBill += d.totalBill || 0; totalPaid += d.totalPaid || 0; totalDiscount += d.finalDiscount || 0; }
  });
  totalBill = Math.round(totalBill);
  totalPaid = Math.round(totalPaid);
  return {
    orderCount, totalBill, totalPaid,
    totalDue:      Math.max(0, totalBill - totalPaid),
    totalDiscount: Math.round(totalDiscount),
    cancelledCount,
    cancelledBill: Math.round(cancelledBill),
  };
};

export const fixOrdersListTotals = async (onProgress) => {
  let lastDoc = null;
  let total = 0;
  const BATCH_SIZE = 20;
  while (true) {
    let queryRef = firestore
      .collection("ordersList")
      .orderBy("createdAt", "desc")
      .limit(BATCH_SIZE);
    if (lastDoc) queryRef = queryRef.startAfter(lastDoc);
    const snapshot = await queryRef.get();
    if (snapshot.empty) break;
    const batch = firestore.batch();
    snapshot.docs.forEach((doc) => {
      const o = doc.data();
      const totalBill =
        (o.subTotal || 0) +
        (o.deliveryCharge || 0) -
        (o.discountApplied || 0) -
        (o.couponApplied ? o.couponApplied.discount || 0 : 0) -
        (o.finalDiscount || 0);
      const totalPaid = (o.payments || []).reduce(
        (s, p) => s + (parseInt(p.amount) || 0),
        0,
      );
      batch.update(doc.ref, { totalBill, totalPaid });
    });
    await batch.commit();
    total += snapshot.docs.length;
    lastDoc = snapshot.docs[snapshot.docs.length - 1];
    if (onProgress) onProgress(total);
    if (snapshot.docs.length < BATCH_SIZE) break;
  }
  return total;
};

export const deleteOrderApi = async (order) => {
  const orderRef = firestore.doc(`ordersApi/${order.orderId}`);
  const snapShot = await orderRef.get();
  if (snapShot.exists) {
    try {
      await orderRef.delete();
    } catch (error) {
      console.log("error deleting order", error.message);
    }
  }
};

// ==================== Wholesale Management: Sourcing ====================

export const getAllSourcings = async (month) => {
  const sourcingsCollectionRef = firestore
    .collection("sourcing")
    .where("month", "==", month);
  try {
    const sourcings = await sourcingsCollectionRef.get();
    const sourcingsArray = [];
    sourcings.forEach((doc) => {
      sourcingsArray.push(doc.data());
    });
    return sourcingsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getAllSourcingsAgent = async (agent, month) => {
  const sourcingsCollectionRef = firestore
    .collection("sourcing")
    .where("agent", "==", agent)
    .where("month", "==", month);
  try {
    const sourcings = await sourcingsCollectionRef.get();
    const sourcingsArray = [];
    sourcings.forEach((doc) => {
      sourcingsArray.push(doc.data());
    });
    return sourcingsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadSourcing = async (sourcingObj) => {
  const sourcingRef = firestore.doc(`sourcing/${sourcingObj.id}`);
  const snapShot = await sourcingRef.get();
  if (!snapShot.exists) {
    try {
      const batch = firestore.batch();
      batch.set(sourcingRef, { ...sourcingObj });
      batch.set(
        monthStatsRef(sourcingObj.month),
        buildMonthStatsDelta(sourcingObj.agent, {
          invoiceCount: 1,
          totalBill: parseFloat(sourcingObj.totalBill) || 0,
          totalPaid: parseFloat(sourcingObj.totalPaid) || 0,
          totalBuyingCost: parseFloat(sourcingObj.buyingCost) || 0,
          totalAgentProfit: parseFloat(sourcingObj.agentPaid) || 0,
          totalProfit: parseFloat(sourcingObj.finalProfit) || 0,
          totalZapaiProfit: parseFloat(sourcingObj.algProfit) || 0,
        }),
        { merge: true },
      );
      await batch.commit();
      const uploadedSnapShot = await sourcingRef.get();
      return uploadedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  }
};

export const updateSourcing = async (sourcingObj) => {
  const sourcingRef = firestore.doc(`sourcing/${sourcingObj.id}`);
  try {
    const beforeSnap = await sourcingRef.get();
    const before = beforeSnap.exists ? beforeSnap.data() : {};
    const after = { ...before, ...sourcingObj };
    const batch = firestore.batch();
    batch.update(sourcingRef, { ...sourcingObj });
    if (before.month) {
      const delta = {
        totalBill:
          (parseFloat(after.totalBill) || 0) -
          (parseFloat(before.totalBill) || 0),
        totalPaid:
          (parseFloat(after.totalPaid) || 0) -
          (parseFloat(before.totalPaid) || 0),
        totalBuyingCost:
          (parseFloat(after.buyingCost) || 0) -
          (parseFloat(before.buyingCost) || 0),
        totalAgentProfit:
          (parseFloat(after.agentPaid) || 0) -
          (parseFloat(before.agentPaid) || 0),
        totalProfit:
          (parseFloat(after.finalProfit) || 0) -
          (parseFloat(before.finalProfit) || 0),
        totalZapaiProfit:
          (parseFloat(after.algProfit) || 0) -
          (parseFloat(before.algProfit) || 0),
        // Refund given (to the customer, already in Tk) and refund taken
        // (from the supplier, in RMB — converted to Tk using the invoice's
        // buy rate) are tracked as their own running totals per month.
        totalRefundGiven:
          sumRefundArray(after.givenRefund) -
          sumRefundArray(before.givenRefund),
        totalRefundTaken:
          (sumRefundArray(after.receivedRefund) -
            sumRefundArray(before.receivedRefund)) *
          (parseFloat(after.buyRate) || 0),
      };
      batch.set(
        monthStatsRef(before.month),
        buildMonthStatsDelta(before.agent, delta),
        { merge: true },
      );
    }
    await batch.commit();
    const snapShot = await sourcingRef.get();
    return snapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const deleteSourcing = async (id) => {
  const sourcingRef = firestore.doc(`sourcing/${id}`);
  try {
    const snapShot = await sourcingRef.get();
    const batch = firestore.batch();
    batch.delete(sourcingRef);
    if (snapShot.exists) {
      const data = snapShot.data();
      batch.set(
        monthStatsRef(data.month),
        buildMonthStatsDelta(data.agent, {
          invoiceCount: -1,
          totalBill: -(parseFloat(data.totalBill) || 0),
          totalPaid: -(parseFloat(data.totalPaid) || 0),
          totalBuyingCost: -(parseFloat(data.buyingCost) || 0),
          totalAgentProfit: -(parseFloat(data.agentPaid) || 0),
          totalProfit: -(parseFloat(data.finalProfit) || 0),
          totalZapaiProfit: -(parseFloat(data.algProfit) || 0),
          totalRefundGiven: -sumRefundArray(data.givenRefund),
          totalRefundTaken:
            -sumRefundArray(data.receivedRefund) *
            (parseFloat(data.buyRate) || 0),
        }),
        { merge: true },
      );
    }
    await batch.commit();
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const getSingleSourcing = async (sourcingId) => {
  const orderRef = firestore.doc(`sourcing/${sourcingId}`);
  try {
    const snapShot = await orderRef.get();
    return snapShot.data();
  } catch (error) {
    return null;
  }
};

export const deleteSourcingProduct = async (sourcingId, productId) => {
  const orderRef = firestore.doc(`sourcing/${sourcingId}`);
  try {
    const snapShot = await orderRef.get();
    await orderRef.update({
      productsArray: snapShot
        .data()
        .productsArray.filter((product) => product.id !== productId),
    });
    const updatedSnapShot = await orderRef.get();
    return updatedSnapShot.data();
  } catch (error) {
    return null;
  }
};

export const handleSourcingCashIn = async (sourcingObj) => {
  const batch = firestore.batch();
  const sourcingRef = firestore.doc(`sourcing/${sourcingObj.id}`);
  const cashInRef = firestore.doc(`dailyCashIn/${sourcingObj.paymentId}`);

  const sourcingSnapShot = await sourcingRef.get();
  const cashInSnapShot = await cashInRef.get();
  const before = sourcingSnapShot.data();

  if (!cashInSnapShot.exists) {
    try {
      batch.set(cashInRef, {
        amount: parseInt(sourcingObj.totalPaid),
        category: "Sourcing",
        subCategory: `${sourcingObj.agent}`,
        note: `Invoice:${sourcingObj.id}
          Date: ${sourcingSnapShot.data().date}`,
        date: sourcingObj.date,
        id: sourcingObj.paymentId,
        month: sourcingObj.month,
        receiveBy: sourcingObj.receiveBy,
        status: "pending",
        unEditable: true,
      });
    } catch (error) {
      notifyError(error.message || String(error));
    }
  }

  const newTotalPaid =
    parseInt(before.totalPaid) + parseInt(sourcingObj.totalPaid);
  const newFinalProfit = newTotalPaid - parseInt(before.buyingCost);
  const newAlgProfit =
    newTotalPaid - parseInt(before.buyingCost) - before.agentPaid;

  batch.update(sourcingRef, {
    ...sourcingObj,
    date: before.date,
    totalPaid: newTotalPaid,
    status: "approved",
    finalProfit: newFinalProfit,
    agentPaid: before.agentPaid,
    algProfit: newAlgProfit,
    invoiceStatus: newTotalPaid >= before.totalBill ? "Paid" : "Not Paid",
  });

  batch.set(
    monthStatsRef(before.month),
    buildMonthStatsDelta(before.agent, {
      totalPaid: parseInt(sourcingObj.totalPaid),
      totalProfit: newFinalProfit - (parseFloat(before.finalProfit) || 0),
      totalZapaiProfit: newAlgProfit - (parseFloat(before.algProfit) || 0),
    }),
    { merge: true },
  );

  try {
    await batch.commit();
    const updatedRef = firestore.doc(`sourcing/${sourcingObj.id}`);
    const snapShot = await updatedRef.get();
    return snapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
    return false;
  }
};

export const handleSourcingCashOut = async (sourcingObj) => {
  const batch = firestore.batch();
  const sourcingRef = firestore.doc(`sourcing/${sourcingObj.id}`);
  const transactionRef = firestore.doc(
    `sourcingTransactions/${sourcingObj.paymentId}`,
  );

  const sourcingSnapShot = await sourcingRef.get();
  const transactionSnapShot = await transactionRef.get();
  const before = sourcingSnapShot.data();

  if (!transactionSnapShot.exists) {
    try {
      batch.set(transactionRef, {
        id: sourcingObj.paymentId,
        amount: parseFloat(sourcingObj.buyingcost2).toFixed(2),
        employeeId: sourcingObj.employeeId,
        paidInvoice: `Invoice:${sourcingObj.id}
          Date: ${sourcingSnapShot.data().date}`,
        month: getMonthName(),
        category: "Sourcing",
        subCategory: `${sourcingObj.agent}`,
        country: sourcingObj.country ? sourcingObj.country : "",
        rmbBalance: sourcingObj.rmbBalance,
        rupeeBalance: sourcingObj.rupeeBalance,
        totalRmb: sourcingObj.totalRmb,
        date: sourcingObj.date,
        expenseBy: sourcingObj.expenseBy,
        buyRate: sourcingObj.buyRate,
        sellRate: sourcingObj.sellRate,
        fundType: sourcingObj.fundType,
      });
    } catch (error) {
      notifyError(error.message || String(error));
    }
  }

  const newFinalProfit =
    parseInt(before.totalPaid) - parseInt(sourcingObj.buyingCost);

  batch.update(sourcingRef, {
    ...sourcingObj,
    date: before.date,
    // `month` is never allowed to move once an invoice is created — callers
    // (e.g. monthly-invoices.js's handleCashOut) pass a freshly-computed
    // "current month" in their payload for their own transaction ledger
    // entry, which must not leak into the invoice's own stored month.
    month: before.month,
    status: "approved",
    finalProfit: newFinalProfit,
  });

  batch.set(
    monthStatsRef(before.month),
    buildMonthStatsDelta(before.agent, {
      totalBuyingCost:
        (parseFloat(sourcingObj.buyingCost) || 0) -
        (parseFloat(before.buyingCost) || 0),
      totalProfit: newFinalProfit - (parseFloat(before.finalProfit) || 0),
      // `algProfit` (unlike finalProfit) isn't recomputed here — it comes
      // straight from the client payload, spread into the doc above.
      totalZapaiProfit:
        (parseFloat(sourcingObj.algProfit) || 0) -
        (parseFloat(before.algProfit) || 0),
    }),
    { merge: true },
  );

  try {
    await batch.commit();
    const updatedRef = firestore.doc(`sourcing/${sourcingObj.id}`);
    const snapShot = await updatedRef.get();
    return snapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
    return false;
  }
};

export const handleSourcingAgentPay = async (sourcingObj) => {
  const batch = firestore.batch();
  const sourcingRef = firestore.doc(`sourcing/${sourcingObj.id}`);
  const expenseRef = firestore.doc(`dailyExpenses/${sourcingObj.paymentId}`);

  const sourcingSnapShot = await sourcingRef.get();
  const expenseSnapShot = await expenseRef.get();
  const before = sourcingSnapShot.data();

  if (!expenseSnapShot.exists) {
    try {
      batch.set(expenseRef, {
        amount: parseInt(sourcingObj.agentPaid),
        category: "Sourcing",
        subCategory: `${sourcingObj.agent}(agent %)`,
        note: `Invoice:${sourcingObj.id}
          Date: ${sourcingSnapShot.data().date}`,
        date: sourcingObj.date,
        id: sourcingObj.paymentId,
        month: sourcingObj.month,
        receiveBy: sourcingObj.receiveBy,
        status: "pending",
        unEditable: true,
      });

      const newAgentPaid = before.agentPaid
        ? parseInt(before.agentPaid) + parseInt(sourcingObj.agentPaid)
        : parseInt(sourcingObj.agentPaid);
      // Subtract only this payment's amount from whatever algProfit already
      // was (which may already reflect refund given/taken adjustments) —
      // recomputing from raw totalPaid/buyingCost here would silently
      // discard those adjustments.
      const newAlgProfit =
        (parseFloat(before.algProfit) || 0) - parseInt(sourcingObj.agentPaid);

      batch.update(sourcingRef, {
        agentPays: sourcingObj.agentPays,
        agentPaid: newAgentPaid,
        status: "approved",
        algProfit: newAlgProfit,
      });

      batch.set(
        monthStatsRef(before.month),
        buildMonthStatsDelta(before.agent, {
          totalAgentProfit: newAgentPaid - (parseFloat(before.agentPaid) || 0),
          totalZapaiProfit:
            newAlgProfit - (parseFloat(before.algProfit) || 0),
        }),
        { merge: true },
      );
    } catch (error) {
      notifyError(error.message || String(error));
    }
  }

  try {
    await batch.commit();
    const updatedRef = firestore.doc(`sourcing/${sourcingObj.id}`);
    const snapShot = await updatedRef.get();
    return snapShot.data();
  } catch (error) {
    notifyError(error.message || String(error));
    return false;
  }
};

export const getAllSourcingTransactions = async (employeeId, month) => {
  const transactionsCollectionRef = firestore
    .collection("sourcingTransactions")
    .where("employeeId", "==", employeeId)
    .where("month", "==", month);
  try {
    const transactions = await transactionsCollectionRef.get();
    const transactionsArray = [];
    transactions.forEach((doc) => {
      transactionsArray.push({ id: doc.id, ...doc.data() });
    });
    return transactionsArray;
  } catch (error) {
    notifyError(error.message || String(error));
  }
};

export const uploadSourcingTransaction = async (transactionObj) => {
  const transactionRef = firestore.doc(
    `sourcingTransactions/${transactionObj.id}`,
  );
  const snapShot = await transactionRef.get();
  if (!snapShot.exists) {
    try {
      await transactionRef.set({ ...transactionObj });
      const uploadedSnapShot = await transactionRef.get();
      return uploadedSnapShot.data();
    } catch (error) {
      notifyError(error.message || String(error));
    }
  } else {
    notifyError(
      "there is already a transaction with similar name, please change the name and try again",
    );
  }
};

export const uploadImageD2dExpressProduct = async (file) => {
  const imageRef = storage.ref(`d2dExpressProduct/${file.name}`);
  try {
    await imageRef.put(file);
    var imgUrl = [];
    await imageRef.getDownloadURL().then((url) => {
      imgUrl.push(url);
    });
    return imgUrl[0];
  } catch (error) {
    return null;
  }
};

export const getAllOrdersByTrackingNo = async (trackingNo) => {
  const ordersCollectionRef = firestore
    .collection("orders")
    .where("trackingNo", "==", trackingNo);
  try {
    const orders = await ordersCollectionRef.get();
    const productsArray = [];
    orders.forEach((doc) => {
      productsArray.push(doc.data());
    });
    return productsArray;
  } catch (error) {
    notifyError(error.message || String(error));
    return [];
  }
};

